webpackJsonp([1],{

/***/ "6ztS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Fv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "89bq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGog":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bhpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KV5D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b688dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("fNxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd1f1a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("KV5D")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ce7210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("JFPs")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-69ce7210"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5864a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("Du5H")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-7ba5864a"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eed32ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}),0)]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("89bq")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9eed32ec"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94907be2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("QRRU")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad378a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}),0)])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Zhdp")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2470dd02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}),0)])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("Bhpb")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f0bddd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("f34v")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8e3a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("mp9z")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfd056f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("gUQz")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5aec612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){return _vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()}),0):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("clAw")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e57029e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1)])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("6ztS")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39079333","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){return _vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])}),0),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("be29")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c984c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205d0721","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}),0)}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("UR7i")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3e62da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("m1X4")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fd9192","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}),0)],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("WI9Y")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-26fd9192"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ee35ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("7Fv8")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6de9100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("gkoj")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01825cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("BGog")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "IGF Biennial Report 2019-20",
  "shortTitle": "",
  "description": "",
  "width": 1273,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [],
  "basePath": "/2019-20",
  // "basePath": "",
  "companyLogo": "logo-white.png",
  "publishURL": "http://reports.igfgolf.org/2019-20/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-title\" src=\"/2019-20/static/_content/logo.png\" style=\"top: 292px; left: 585px;\"/>\n        <img class=\"halfScale 1-title\" src=\"/2019-20/static/_content/1-title-1.png\" style=\"top: 392px; left: 548px;\"/>\n        <img class=\"halfScale 1-title\" src=\"/2019-20/static/_content/1-sub-1.png\" style=\"top: 537px; left: 608px;\"/>\n\n        <img class=\"1-arrows pointer\" src=\"/2019-20/static/_content/right-arrow-white.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg1Anim = new TimelineMax();\n        pg1Anim.staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:-30}, {opacity:1, y:0}, 0.2, 1)        \n        .fromTo(cOf(\"1-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: function() {\n          addPulse(\"1-arrows\")\n          addContentLinks()\n        }}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg1Anim.stop();\n      }\n      ",
    "searchText": "IGF  BIENNIAL REPORT 2019 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 2-title\" src=\"/2019-20/static/_content/2-title-1.png\" style=\"top: 110px; left: 467px;\">\n      \n      <img class=\"2-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"2-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      \n      <div class=\"contentLinkNone addContentLink\" style=\"top: 209px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(3)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 268px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(4)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 327px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(5)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 386px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(6)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 445px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(7)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 504px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(8)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 563px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(9)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 622px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(10)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 681px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(11)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 740px;left: 63px;width: 347px;height: 38px;\" onclick=\"Publish.goToPage(12)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 209px;left: 504px;width: 267px;height: 57px;\" onclick=\"Publish.goToPage(13)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 287px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(14)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 346px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(15)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 405px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(16)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 464px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(17)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 523px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(18)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 582px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(19)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 641px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(20)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 700px;left: 504px;width: 267px;height: 38px;\" onclick=\"Publish.goToPage(21)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 209px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(22)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 268px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(23)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 327px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(24)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 386px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(25)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 445px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(26)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 504px;left: 922px;width: 232px;height: 57px;\" onclick=\"Publish.goToPage(27)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 582px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(28)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 641px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(29)\"></div>\n      <div class=\"contentLinkNone addContentLink\" style=\"top: 700px;left: 922px;width: 232px;height: 38px;\" onclick=\"Publish.goToPage(30)\"></div>\n      <a href=\"http://www.igfgolf.org\" target=\"_blank\">\n        <div class=\"addContentLink\" style=\"bottom: 22px;right: 80px;width: 115px;height: 23px;\"></div>\n      </a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg2Anim = new TimelineMax();\n        pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 1)\n        .fromTo(cOf(\"2-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: function() {\n          addPulse(\"2-arrows\")\n          addContentLinks()\n        }}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg2Anim.stop();\n        removePulse(\"2-arrows\");\n        removeContentLinks();\n      }\n      ",
    "searchText": "2  CONTENTS  IGF Biennial Report 2019-20  CONTENTS IGF PRESIDENT’S MESSAGE IGF EXECUTIVE DIRECTOR’S REPORT IGF BOARD IGF ADMINISTRATIVE COMMITTEE IGF EXECUTIVE COMMITTEE IGF ATHLETES’ COMMITTEE IGF COMPETITIONS COMMITTEE IGF COACHING & DEVELOPMENT COMMITTEE IGF MEDICAL COMMITTEE  IGF GOLFERS WITH DISABILITIES COMMITTEE & IPC RELATIONS SUSTAINABILITY IOC RELATIONS ASOIF RELATIONS GAISF RELATIONS  WATC SINGAPORE 2020 YOG DAKAR 2022 WATC FRANCE 2022 WATC 2023 OLYMPIC GAMES PARIS 2024  NATIONAL FEDERATION MEMBERS  OTHER MULTI-SPORT EVENTS AND ORGANISATIONS  WATC IRELAND 2018  IGF FINANCIAL REPORT 2018  YOG BUENOS AIRES 2018  IGF FINANCIAL REPORT 2019  OLYMPIC GAMES TOKYO 2020  APPENDICES  IGF ANTI-DOPING COMMITTEE  INTERNATIONAL GOLF FEDERATION Avenue de Rhodanie 54 1007 Lausanne, Switzerland  Tel +41 21 623 12 12 Fax +41 21 601 64 77 www.igfgolf.org"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"3-title halfScale\" src=\"/2019-20/static/_content/3-1-title-1.png\" style=\"top:144px; left: 419px;\">\n      <img class=\"3-title halfScale\" src=\"/2019-20/static/_content/3-1-sub-1.png\" style=\"top: 216px; left: 237px;\">\n      <img class=\"3-img halfScaleC\" src=\"/2019-20/static/_content/3-1-img-1.png\" style=\"top: 267px; left: 456px;\">\n      <img class=\"3-name halfScale\" src=\"/2019-20/static/_content/3-1-sub-2.png\" style=\"top: 556px; left: 571px;\">\n\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg3Anim = new TimelineMax();\n        pg3Anim.staggerFromTo(cOf(\"3-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"3-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"3-name\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, \"-=0.2\")\n        .fromTo(cOf(\"3-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"3-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg3Anim.stop();\n        removePulse(\"3-arrows\")\n      }\n      ",
    "searchText": "3  IGF Biennial Report 2019-20  IGF PRESIDENT’S MESSAGE  IGF President’s Message “The comradeship and goodwill consistently demonstrated by golf people is our sport’s greatest strength and I could not have wished for greater support during my term as President.” This is my final message as President of the International Golf Federation (IGF) as I will be retiring at the end of 2020, and perhaps this is a natural time to pause for some reflection on our progress and to think of the challenges ahead.  the professional game and in addition to our long-standing National Federation (NF) membership we now boast the inclusion of golf’s major championship organisers, professional tours and PGAs. PETER DAWSON  Much has been achieved and our organisation has expanded enormously from its beginnings in 1958 as the World Amateur Golf Council. After many years of hard work we were successful in our bid to reinstate golf to the programme of Olympic sports at the Copenhagen International Olympic Committee (IOC) session in 2009. Our return events in  2016 in Rio de Janeiro were met with great acclaim and we have established golf as a core Olympic sport until at least 2028. These accomplishments were made possible by a total restructuring of our organisation to include READ MORE  Golf’s history dictates that our sport’s governance has evolved in a different way from many others. Nonetheless it clearly works well and it has been extremely gratifying that Olympic golf has been such a powerful catalyst for further strengthening the bonds and cooperation between the bodies which lead our great game so well."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 3-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg3Anim = new TimelineMax();\n        pg3Anim.staggerFromTo(cOf(\"3-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"3-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"3-name\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, \"-=0.2\")\n        .fromTo(cOf(\"3-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"3-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg3Anim.stop();\n        removePulse(\"3-arrows\")\n      }\n      ",
    "searchText": "3  Since Copenhagen 2009 the IGF has been busy both on and off the golf course. As well as golf’s return to the Olympics in Rio we have staged memorable competitions in two Youth Olympic Games, in Nanjing and Buenos Aires. With the traditional involvement of The R&A and the USGA we have continued to organise the World Amateur Team Championships (WATC) in Argentina, Turkey, Japan, Mexico and most recently in Ireland. All of these events have been fiercely competitive while at the same time demonstrating the lasting friendships which sport can inspire. We have forged an increasingly strong relationship with the IOC  IGF PRESIDENT’S MESSAGE  and have achieved recognition as the International Federation representing golf by the International Paralympic Committee. Of particular note is the 34% increase in our NF membership from 110 to 151 reflecting golf’s international growth and the importance of Olympic sports to so many nations. All of these past achievements are certainly positive for golf but the present is of course dominated by the misery and uncertainty caused by the COVID-19 pandemic in every aspect of our lives. In our world it has caused Tokyo 2020 to be postponed and the 2020 WATC to be cancelled, and it  IGF Biennial Report 2019-20  is simply not possible to predict the immediate future with any confidence. In such challenging circumstances it was good to see that golf was one of the first sports to return to active competition albeit without fans present at the venues. The organisers are to be congratulated on the safe and efficient operation of these events and I hope we can use the foundations they have built to ensure that we can continue to enjoy top level competition in these difficult times. For golf, one heartening effect of the pandemic has been a rapid rise in our game’s popularity as lengthy periods of lockdown have reinforced the value of regular outdoor exercise."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"3-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg3Anim = new TimelineMax();\n        pg3Anim.staggerFromTo(cOf(\"3-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"3-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"3-name\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, \"-=0.2\")\n        .fromTo(cOf(\"3-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"3-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg3Anim.stop();\n        removePulse(\"3-arrows\")\n      }\n      ",
    "searchText": "Golf facilities around the world have reported substantial increases in rounds played and membership numbers, and the challenge for our NFs is to find ways of making these gains permanent in the tough economic times which surely lie ahead.  IGF PRESIDENT’S MESSAGE  IGF Biennial Report 2019-20  Credit: Pablo Elías/Buenos Aires 2018  3  IGF President Peter Dawson and IOC President Thomas Bach, YOG 2018  Looking to the future, the IGF will remain committed to representing our sport as an active and contributing member of the Olympic Family and to ensuring that golf avails itself of the benefits that our Olympic status can bring.  our work, our NFs stage our events and supply the volunteers who give so freely of their time, and our dedicated and capable staff are second to none.  So many organisations and individuals work hard to help the IGF achieve its aims. Our delivery partners provide much of the resource necessary for  Our Executive Director, Antony Scanlon, and our Vice President, Ty Votaw, have applied their wealth of experience to positioning golf in the Olympic world.  It has been a privilege and pleasure for me to work with them both. The comradeship and goodwill consistently demonstrated by golf people is our sport’s greatest strength and I could not have wished for greater support during my term as President. My thanks and best wishes to all."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"4-title halfScale\" src=\"/2019-20/static/_content/4-1-title-1.png\" style=\"top:417px; left: 58px;\">\n      <img class=\"4-title halfScale\" src=\"/2019-20/static/_content/4-1-sub-1.png\" style=\"top: 345px; left: 157px;\">\n      <img class=\"4-img halfScaleC\" src=\"/2019-20/static/_content/4-1-img-1.png\" style=\"top: 55px; left: 55px;\">\n\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 4-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 4-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 4-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"4-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"4-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"4-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg4Anim.stop();\n        removePulse(\"4-arrows\")\n      }\n      ",
    "searchText": "4  IGF EXECUTIVE DIRECTOR’S REPORT  ANTONY SCANLON  IGF Executive Director’s Report  due to the COVID-19 pandemic. No one would have predicted the times of extreme uncertainty that we are now experiencing, nor the far-reaching consequences of the coronavirus crisis around the world. This pandemic has significantly affected all areas of society, including all of us in golf. The unprecedented decisions of the International Olympic Committee  Dear Members, Much has happened since the 2018 Biennial meeting and the exciting 2018 World Amateur Team Championships (WATC) held in Ireland where there was heightened enthusiasm about the future growth of our sport. No one would have conceived back then that the world would be changed so dramatically READ MORE  IGF Biennial Report 2019-20  (IOC) to postpone the Olympic Games Tokyo 2020 and the IGF to cancel the 2020 WATC, have impacted the IGF substantially. Accordingly, like many of you, the IGF undertook an immediate review of the effects the COVID-19 pandemic has had (and will continue to have) on the financial and operational activities of the IGF for 2020. This review reconfirmed the strength IGF Lausanne staff and adaptability of the IGF’s delivery model, which consists of a small number of core staff and the reliance on our Delivery Partners’ resources to deliver our specific projects and day-to-day activities."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"4-title halfScale\" src=\"/2019-20/static/_content/4-2-quote-1.png\" style=\"top: 218px; left: 63px;\">\n\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"4-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"4-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg4Anim.stop();\n        removePulse(\"4-arrows\")\n      }\n      ",
    "searchText": "4  “We quickly secured financing from the IGF Delivery Partners and the IOC to ensure continuity in our operations and the delivery of the Olympic Games in 2021.” We were able to quickly cancel or suspend a number of projects and modify our operations to work remotely and achieve efficiencies without seriously impacting the delivery of our key activities or the immediate issue of dealing with the postponement of the Olympic Games Tokyo 2020. With no Olympic Games in 2020, the IGF does not receive the IOC’s contribution for golf’s participation at Tokyo 2020. However, we quickly secured financing from the IGF Delivery Partners and  IGF EXECUTIVE DIRECTOR’S REPORT  the IOC to ensure continuity in our operations and the delivery of the Olympic Games in 2021. The 2020 Biennial meeting will see the implementation of the changes to the IGF Constitution that were passed at the 2016 Biennial meeting which will increase the representation of women on the 2020-2022 Administrative Committee and appoint a Women’s Chair to the IGF Board. These gender equality initiatives will provide greater opportunities for women to contribute in roles of influence and decisionmaking in our sport and will encourage diversity of opinion, which is a key factor of good governance. We will continue to take a leadership role and to promote and implement more gender equality initiatives within the  IGF Biennial Report 2019-20  IGF and implore the IGF membership to appoint more women to leadership roles within their administration and governance, as well as advocate and implement significant gender equality initiatives so that girls and women are given greater access and opportunity to play golf.  Emilie Oeveraas of Norway, YOG 2018"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"4-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        pg4Anim.fromTo(cOf(\"4-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"4-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg4Anim.stop();\n        removePulse(\"4-arrows\")\n      }\n      ",
    "searchText": "4  The year 2020 will end the implementation of the IGF’s first Strategic Plan where we have been able to deliver the following key initiatives, including:  IGF EXECUTIVE DIRECTOR’S REPORT   successful delivery of Youth Olympic Games Nanjing 2014 and Buenos Aires 2018;  successful delivery of four WATCs;   consolidating a place on the Olympic Games programme through to 2028;  strengthening relationships with the Olympic Movement through the IGF’s active participation in Commissions and working groups;  successful delivery of Olympic Games Rio 2016; Jordan Thompson of Nigeria, YOG 2018   thirty-four per cent growth in National Federation (NF) Memberships – 110 to 151;  recognition as the International Federation (IF) for golf by International Paralympic Committee (IPC);  compliance with World Anti-Doping Agency (WADA) Anti-Doping Code;  compliance with Association of Summer Olympic International Federations (ASOIF) Principles of Governance and IOC Code of Ethics; and  IGF Biennial Report 2019-20   creation of International Golf Coaching Framework. Following the 10 December 2019 Board meeting, the IGF Board held a Strategic Planning Session to reflect on its current structures, strategies, activities and approach to delivery. The insights and perspectives provided by the Board during this session and on the strategic direction of the IGF are now being used to develop the strategic business plan for the period 20212028. The final version of the plan will be approved by the IGF Board at the December 2020 Board meeting. With three Olympic Games, a Youth Olympic Games and five WATCs to be delivered during this period, we have much to look forward to and many opportunities to showcase the greatness of our sport and inspire the growth of golf around the world."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"5-title halfScale\" src=\"/2019-20/static/_content/5-title-1.png\" style=\"top: 114px; left: 57px;\">\n\n      <img class=\"5-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"5-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg5Anim = new TimelineMax();\n        pg5Anim.staggerFromTo(cOf(\"5-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"5-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"5-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg5Anim.stop();\n        removePulse(\"5-arrows\")\n      }\n      ",
    "searchText": "5  IGF Biennial Report 2019-20  IGF BOARD  IGF Board The member federations appoint the Board Members to govern the IGF. The IGF Board maintains a strategic focus in its governance of golf. However,  the responsibility for implementing the Strategic Plan and managing the IGF’s operating activities rests with the Executive Director.  IGF Board Members  PETER DAWSON PRESIDENT (IGF)  KEITH PELLEY (EUROPEAN TOUR)  TY VOTAW VICE PRESIDENT (IGF)  MARTIN SLUMBERS (THE R&A)  JAY MONAHAN CHAIR (PGA TOUR)  SETH WAUGH (PGA OF AMERICA)  MIKE DAVIS (UNITED STATES GOLF ASSOCIATION)  SIDNEY WOLF (PUERTO RICO GOLF ASSOCIATION)  NOBUKO HIRAYAMA (JAPAN GOLF ASSOCIATION) WILL JONES (AUGUSTA NATIONAL GOLF CLUB)  MIKE WHAN (LPGA)  Olivia Mehaffey of Ireland, WATC 2018  IGF Board Meetings  The IGF Board met on the following occasions  4 December 2018  10 December 2019  10 April 2019   8 April 2020   16 July 2019   14 July 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"6-title halfScale\" src=\"/2019-20/static/_content/6-1-title-1.png\" style=\"top:298px; left: 55px;\">\n\n      <img class=\"6-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"6-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 6-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 6-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 6-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg6Anim = new TimelineMax();\n        pg6Anim.staggerFromTo(cOf(\"6-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"6-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"6-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg6Anim.stop();\n        removePulse(\"6-arrows\")\n      }\n      ",
    "searchText": "6  IGF ADMINISTRATIVE COMMITTEE  IGF Biennial Report 2019-20  Mohamed Alhajeri of the United Arab Emirates, YOG 2018  IGF Administrative Committee The Administrative Committee is responsible for the approval of National Federation (NF) Membership, the oversight of the organisation of the golf competition at the Youth Olympic Games and the WATC and the financing of the IGF’s activities undertaken by the Executive Committee. The Committee also oversees the interaction between NF Members and National Olympic Committees (NOCs). READ MORE"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"6-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"6-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(cOf(\"6-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"6-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg6Anim.stop();\n        removePulse(\"6-arrows\")\n      }\n      ",
    "searchText": "6  IGF Biennial Report 2019-20  IGF ADMINISTRATIVE COMMITTEE  Administrative Committee Members  IAN PATTINSON JOINT CHAIR (THE R&A)  ANTTI PELTONIEMI (FINNISH GOLF UNION)  NAADIR AGHERDIEN (SOUTH AFRICAN GOLF ASSOCIATION)  MIKE DAVIS JOINT CHAIR (UNITED STATES GOLF ASSOCIATION)  VACANT (INDIAN GOLF UNION)  JOHN BODENHAMER (UNITED STATES GOLF ASSOCIATION)  CLAUDIA CAMARGO IGF WOMEN’S CHAIR (MEXICAN GOLF FEDERATION) MIGUEL LEESON (ARGENTINE GOLF ASSOCIATION) ROBERT ARMOUR (GOLF AUSTRALIA) LAURENCE APPLEBAUM (GOLF CANADA) DESIRÉE SOULODRE PIZARRO (CHILE GOLF FEDERATION) ZHANG XIAONING (CHINA GOLF ASSOCIATION)  NOBUKO HIRAYAMA (JAPAN GOLF ASSOCIATION) HYUNG-MO KANG (KOREA GOLF ASSOCIATION) CAROLINE HUYSKES (NETHERLAND GOLF FEDERATION) SIDNEY WOLF (PUERTO RICO GOLF ASSOCIATION) GONZAGA ESCAURIAZA (ROYAL SPANISH GOLF FEDERATION) ALICK BISSET (THE R&A)  Administrative Committee Meetings  The Administrative Committee met on the following occasions:  16 January 2020  5 May 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      <img class=\"7-title halfScale\" src=\"/2019-20/static/_content/7-title-1.png\" style=\"top: 175px; left: 460px;\">\n\n      <img class=\"7-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"7-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg7Anim = new TimelineMax();\n        pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"7-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"7-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg7Anim.stop();\n        removePulse(\"7-arrows\")\n      }\n      ",
    "searchText": "7  IGF Biennial Report 2019-20  IGF EXECUTIVE COMMITTEE  IGF Executive Committee The Executive Committee is responsible for the approval of Professional Membership, the oversight of the organisation of the golf competition at  the Olympic Games and the financing of the IGF’s activities undertaken by the Executive Committee.  Executive Committee Members  PETER DAWSON PRESIDENT (IGF) TY VOTAW VICE PRESIDENT (IGF)  Takumi Kanaya of Japan, WATC 2018  MIKE DAVIS (UNITED STATES GOLF ASSOCIATION)  WILL JONES (AUGUSTA NATIONAL GOLF CLUB) JAY MONAHAN (PGA TOUR) KEITH PELLEY (EUROPEAN TOUR)  MARTIN SLUMBERS (THE R&A) SETH WAUGH (PGA OF AMERICA) MR MIKE WHAN (LPGA)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"8-title halfScale\" src=\"/2019-20/static/_content/8-1-title-1.png\" style=\"top:168px; left: 55px;\">\n\n      <img class=\"8-arrows pointer\" src=\"/2019-20/static/_content/left-arrow-white.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"8-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 8-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 8-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 8-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg8Anim = new TimelineMax();\n        pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"8-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"8-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg8Anim.stop();\n        removePulse(\"8-arrows\")\n      }\n      ",
    "searchText": "8  IGF Athletes’ Committee  Blanca Fernández Garcia-Poggio of Spain, YOG 2018  IGF ATHLETES’ COMMITTEE  The IGF recognises the importance of the rights and obligations of our athletes.  The IGF Athletes’ Committee acts as a consultative body and link between active athletes and ensures that their interests are protected. The Athletes’ Committee met on 11 March 2019 at the PGA TOUR HQ, as every year, where all key aspects of competition rules and athlete services planning for the Olympic Games Tokyo 2020 were discussed. An outline of Tokyo’s climate, the heat conditions expected in summer and foreseen countermeasures were also presented. Athlete representatives on the Committee provided valuable feedback and recommendations on the draft plans, demonstrating once READ MORE  IGF Biennial Report 2019-20  again the absolute necessity, and added value, of involving athletes at the heart of Olympic Games project planning. In April 2019, our Athletes’ Committee Chair, Heather Daly-Donofrio, attended the ninth edition of the International Athletes’ Forum, organised by the IOC in Lausanne, Switzerland, together with some 350 athlete representatives from 185 National Olympic Committees (NOCs), 50 IFs and other Olympic Movement constituents. During the course of the Forum, the attendees devised concrete proposals to further increase support for athletes at all levels. In August 2019, the Athletes’ Committee Chair, together with a wider IGF Delegation, attended the Golf Test Event at the Kasumigaseki Country"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"8-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"8-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg8Anim = new TimelineMax();\n        pg8Anim.fromTo(cOf(\"8-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"8-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg8Anim.stop();\n        removePulse(\"8-arrows\")\n      }\n      ",
    "searchText": "8  IGF ATHLETES’ COMMITTEE  Club (KCC), the venue for the Tokyo 2020 Olympic golf competition, to observe delivery components of both competition and venue operations. Ms Daly-Donofrio and the IGF Delegation contributed to the debrief and outlined the lessons learnt with the Tokyo 2020 Organising Committee to adapt and fine-tune their operational plans.  The Athletes’ Committee met again on 9 March 2020 at the PGA TOUR HQ, where the latest status of preparations for the Olympic Games Tokyo 2020, especially in the field of athlete servicing, were presented. The developing COVID-19 pandemic and potential impacts on athlete training and qualifications for the  IGF Biennial Report 2019-20  Games known at that time were also discussed. After the IOC decided to postpone the Olympic Games, the Athletes’ Committee, through the Athlete Relations liaisons, actively informed the athletes and their entourage of the situation and related developments, and continues to do so.  Athlete Members Athletes’ Committee Members THONGCHAI JAIDEE (THAILAND) HEATHER DALY-DONOFRIO CHAIR (LPGA)  DAVID GARLAND (EUROPEAN TOUR)  DAVID PARK (EUROPEAN TOUR)  SUZANN PETTERSEN (NORWAY)  ALEXIS ABRAHAM (LPGA)  DAVIDE LANTOS (LADIES EUROPEAN TOUR)  BILLY SCHRODER (PGA TOUR)  SO YEON RYU (KOREA)  TYLER DENNIS (PGA TOUR)  ANDY LEVINSON (PGA TOUR)  MICHAEL WOOD (LADIES EUROPEAN TOUR)  ALENA SHARP (CANADA) HENRIK STENSON (SWEDEN)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"9-title halfScale\" src=\"/2019-20/static/_content/9-1-title-1.png\" style=\"top:149px; left: 58px;\">\n      <img class=\"9-title halfScale\" src=\"/2019-20/static/_content/9-1-sub-1.png\" style=\"top: 247px; left: 54px;\">\n\n      <img class=\"9-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"9-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 9-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 9-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 9-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg9Anim = new TimelineMax();\n        pg9Anim.staggerFromTo(cOf(\"9-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"9-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"9-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg9Anim.stop();\n        removePulse(\"9-arrows\")\n      }\n      ",
    "searchText": "9  IGF COMPETITIONS COMMITTEE  IGF Competitions Committee Overseeing Olympic golf The IGF Competitions Committee aims to ensure the best Olympic golf events possible by overseeing the management and presentation of the Olympic golf competitions.  Competitions Committee Members  TYLER DENNIS CHAIR (PGA TOUR) HEATHER DALY-DONOFRIO (LPGA)  The Competitions Committee makes sure that all athletes nominated to compete in the Olympic golf competition are eligible to participate. It also recommends referees and officials for the Olympic golf competition. The Olympic Games function (OGF) provides support to the Competitions Committee. It works closely with the Organising Committee for the Olympic Games (OCOG) to ensure that all elements of the venues and the field of play conform to IGF technical  IGF Biennial Report 2019-20  DAVID GARLAND (EUROPEAN TOUR) KERRY HAIGH (PGA OF AMERICA) DAVIDE LANTOS (LADIES EUROPEAN TOUR)  Mateo Fernández de Oliveira and Ela Anacona of Argentina (bronze medallists), YOG 2018  standards. The OGF also oversees the overall service provision to athletes, IGF personnel and technical officials READ MORE  SHONA MCRAE (THE R&A) THOMAS PAGEL (UNITED STATES GOLF ASSOCIATION)"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"9-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"9-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg9Anim = new TimelineMax();\n        pg9Anim.fromTo(cOf(\"9-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"9-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg9Anim.stop();\n        removePulse(\"9-arrows\")\n      }\n      ",
    "searchText": "9  IGF COMPETITIONS COMMITTEE  IGF Biennial Report 2019-20  Alessia Nobilio of Italy (silver medallist), Grace Kim of Australia (gold medallist) and Emma Spitz of Austria (bronze medallist), YOG 2018  at the competition venues to enable them to conduct their Games-time roles, in support of the competition. During the Olympic Games Tokyo 2020, the IGF will oversee the running of the Olympic event in conjunction with the Tokyo 2020 Organising Committee and provide the focal point for OCOG contact in relation to competition issues. As was done for the Olympic Games Rio 2016, the Competitions Committee released the Olympic Golf Regulations for Tokyo 2020 which provide the official rules and regulations for the Olympic golf competition. They include both field of play policies and procedures as well as Olympic-specific regulations.  On the occasion of the Golf Test Event in August 2019 at the Kasumigaseki Country Club, the venue for the Olympic Games Tokyo 2020, a number of the Committee  members travelled to Tokyo to observe course conditions at that time of year and progress on planning for the set-up of the course for the Olympic events."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"10-title halfScale\" src=\"/2019-20/static/_content/10-1-title-1.png\" style=\"top:204px; left: 58px;\">\n      <img class=\"10-title halfScale\" src=\"/2019-20/static/_content/10-1-sub-1.png\" style=\"top: 280px; left: 54px;\">\n\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 10-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 10-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 10-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.staggerFromTo(cOf(\"10-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"10-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"10-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removePulse(\"10-arrows\")\n      }\n      ",
    "searchText": "10  IGF COACHING & DEVELOPMENT COMMITTEE  IGF Biennial Report 2019-20  IGF Coaching & Development Committee The IGF Coaching & Development Committee is responsible for the development of golf, from grassroots to the highest levels, with the aim of inspiring future players and fans to play golf and increase participation in the sport.  Coaching & Development Committee Members DOMINIC WALL CHAIR (THE R&A)  ANDREW GUNN (PGA OF SOUTH AFRICA)  KYLE PHILLPOTS (IGF ADVISOR)  MATT ALLEN (PGA OF CANADA)  JOHAN HAMPF (PGA OF SWEDEN)  GEOFF STEWART (PGA OF AUSTRALIA)  ARJUN CHOWDRI (PGA OF AMERICA)  MARTIN HASENBEIN (PGA OF GERMANY)  MARTIN WESTPHAL (CONFEDERATION OF PROFESSIONAL GOLF)  DAVID COLCLOUGH (THE PROFESSIONAL GOLFERS’ ASSOCIATION)  DAWES MARLATT (PGA OF AMERICA)  READ MORE"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.fromTo(cOf(\"10-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"10-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removePulse(\"10-arrows\")\n      }\n      ",
    "searchText": "10  IGF Biennial Report 2019-20  IGF COACHING & DEVELOPMENT COMMITTEE  The Coaching & Development Committee is currently working towards developing qualification specifications for each of the four levels of coaching qualifications and awards, as per the objectives defined in the IGF Coaching Framework. The collaboration and contribution of several education experts from the PGAs and The R&A is critical to the project and is highly valued.  Olympic Solidarity A number of IGF National Federation (NF) Members applied for Olympic Solidarity funding for the organisation of Technical Courses for Coaches through their National Olympic Committee (NOC). Unfortunately, due to the COVID-19 pandemic and restrictions in international travel, courses scheduled to take place  Technical Course for Coaches in Tunisia  in Lebanon and Benin have been put on hold.  Courses that have been conducted to date: NATIONAL OLYMPIC COMMITTEE  NATIONAL FEDERATION  COURSE LEVEL  COURSE DATES  Colombia  Colombian Golf Federation  Pilot course between Level 1 and Level 2  April 2017  Vietnam  Vietnam Golf Association  Level 1  April 2018  Bahrain  Bahrain Golf Association  Level 1  October 2018  Malta  Malta Golf Association  Modular Course for Coaches – ‘Golf to School’ project  October 2018, May 2019 November 2019, May 2020 – postponed  Tunisia  Tunisia Golf Federation  Level 2  February 2019 – L2 course September 2019 – assessment  Afghanistan  Afghanistan Golf Federation  Introduction course + Level 1  March 2019"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"10-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.fromTo(cOf(\"10-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"10-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removePulse(\"10-arrows\")\n      }\n      ",
    "searchText": "10  IGF COACHING & DEVELOPMENT COMMITTEE  Olympic Scholarships for Coaches and Development of National Sport Systems are additional programmes offered by Olympic Solidarity under its ‘Coaches Programme Unit’. These give NOCs the possibility of further incorporating coach training into their strategic plans. The IGF has received the first applications  Technical Course for Coaches in Colombia  for these programmes through Olympic Solidarity and encourages the NFs to explore these opportunities further.  Olympic Scholarships for Athletes ‘Tokyo 2020’  There are nine scholarship holders for golf: NATIONAL OLYMPIC COMMITTEE  IGF Biennial Report 2019-20  ATHLETE  Morocco  Maha Haddioui  Chile  Joaquin Niemann Zenteno  Virgin Islands  Amira Alexander  Paraguay  Arnaldo Fabrizio Zanotti Cavazzoni  Paraguay  Julieta Pa Granada  Saudi Arabia  Hanee Anbarserri  Bulgaria  Lyubomir Kostov  Ireland  Leona Maguire  Israel  Laetitia Beck  This Olympic Solidarity programme is aimed at all NOCs and their athletes, particularly those with the greatest need, by providing financial and technical support to elite athletes with the potential to qualify for the Olympic Games. The scholarship provides athletes with access to the appropriate facilities in their own country or to a training centre abroad, where they will receive suitable technical, medical and scientific support, as well as reimbursement of travel expenses for Olympic qualifying competitions."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"11-title halfScale\" src=\"/2019-20/static/_content/11-1-title-1.png\" style=\"top:174px; left: 54px;\">\n      <img class=\"11-title halfScale\" src=\"/2019-20/static/_content/11-1-sub-1.png\" style=\"top: 307px; left: 54px;\">\n\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 11-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 11-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 11-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg11Anim = new TimelineMax();\n        pg11Anim.staggerFromTo(cOf(\"11-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"11-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"11-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg11Anim.stop();\n        removePulse(\"11-arrows\")\n      }\n      ",
    "searchText": "11  IGF Medical Committee Ensuring a healthy sport The IGF Medical Committee provides medical advice to the IGF and deals with all medical issues enabling or encouraging participation in golf as a safe and healthy sport. The mission for the Medical Committee for the coming years is to:  IGF MEDICAL COMMITTEE  Committee for the Olympic Games (OCOG) and defining requirements for athletes and spectators  Participate in meetings and research and advise on topical medical issues such as injury and illness reporting and gender.  IGF Medic al C ommit tee Meetings  11 March 2019 and 9 March 2020 at the PGA TOUR headquarters in Ponte Vedra (USA);   Provide event coverage (staffing) for the Olympic Games   19 September 2019 at BMW PGA Championship in Wentworth (UK);   Discuss medical policy and procedures for the Olympic Games, in particular working with the Organising   phone meetings on 22 May 2019 and 4 February 2020 on gender issues. READ MORE  IGF Biennial Report 2019-20  Medical Committee Members  TOM HOSPEL CHAIR (PGA TOUR) ROGER HAWKES (EDGA) JONATHON LAVELLE (THE R&A) ANDREW MURRAY (EUROPEAN TOUR) PATRICK SCHAMASCH (IGF ADVISOR) BRUCE THOMAS (LPGA) MARK WOTHERSPOON (LADIES EUROPEAN TOUR)"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg11Anim = new TimelineMax();\n        pg11Anim.fromTo(cOf(\"11-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"11-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg11Anim.stop();\n        removePulse(\"11-arrows\")\n      }\n      ",
    "searchText": "11  IGF MEDICAL COMMITTEE  IGF Biennial Report 2019-20  18th hole, East Course, Kasumigaseki Country Club   The IGF Office is in regular contact with the Tokyo 2020 Organising Committee about the medical services that will be provided during the Olympic Games. At the time of writing, Tokyo has yet to communicate to the IGF whether the decision to postpone will have any impact on the medical services.  The IGF will send two medical doctors and three physiotherapists to the Olympic Games Tokyo 2020 in order for the golf athletes to receive the best level of medical care. Due to differing policies,  Koji Aoki/AFLO  Olympic Games Tokyo 2020 – Medical Services  these health professionals will not be incorporated into the Organising Committee’s volunteer workforce as was the case in Rio and will instead be accredited by the IGF as part of the IGF medical team.  IGF Extreme Heat Guidelines  The IGF developed the IGF Extreme Heat Guidelines and published these non-mandatory guidelines in September 2019. The guidelines"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg11Anim = new TimelineMax();\n        pg11Anim.fromTo(cOf(\"11-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"11-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg11Anim.stop();\n        removePulse(\"11-arrows\")\n      }\n      ",
    "searchText": "11   The IGF has provided the Tokyo 2020 Organising Committee with recommendations for the golf event based on the IGF Extreme Heat Guidelines, and the IGF is monitoring closely the overlay plans and the positioning of not only the athlete heat mitigation initiatives that will be deployed at KCC but also those for the spectators. Caterina Don of Italy, WATC 2018  contain risk factors, mitigation strategies and recommendations that can be applied to any golf event for players, caddies and spectators.  IGF Biennial Report 2019-20  IGF MEDICAL COMMITTEE  Prevention of injury and illness in golf  A project to create an international consensus on the reporting of injuries and illnesses in golf has been carried out throughout 2020 and led by Medical Committee  member, Dr Andrew Murray. The aim of this consensus is the systematic and harmonised collection of epidemiological data in order to have more robust data to inform injury and illness prevention strategies in golf.  The international consensus for golf has been drafted and agreed upon and is expected to be published in a reputable scientific journal in the second half of 2020.  Gender  There is much debate at an international level between medical, sports and human"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11-4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"11-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg11Anim = new TimelineMax();\n        pg11Anim.fromTo(cOf(\"11-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"11-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg11Anim.stop();\n        removePulse(\"11-arrows\")\n      }\n      ",
    "searchText": "11  rights professionals as to the best way to approach transgender, hyperandrogenism and disorders of sex development (DSD) in order to maintain a level playing field in sport.  The IGF follows the guidance of the IOC in this area and, at the time of writing, the IOC are in the process of updating their gender guidelines. The IGF is reticent to implement any gender specific eligibility rules with testosterone limits in golf at this stage without the IOC’s active backing or leadership.  A transgender case study in golf is  IGF Biennial Report 2019-20  IGF MEDICAL COMMITTEE  currently underway in England at Loughborough University.  The Golf and Health Research Project  Several members of the Medical Committee have been involved in this project, supported by the World Golf Foundation, which has shown evidence that golfers live longer, have better overall health and gain wellness and mental health benefits due to a combination of walking, muscular activity and social interaction. The project is receiving global interest and more studies are underway.  COVID-19  Throughout March 2020, the IGF Office provided regular and relevant updates on the Olympic Games Tokyo 2020 and the COVID-19 pandemic to the IGF Athletes’ Committee, the IGF Medical Committee, the IGF Anti-Doping Committee, the IGF Competitions Committee, the IGF International Technical Officials (ITOs) and IGF Olympic staff. These updates contained information on official IGF statements and communications received by the IOC, Tokyo 2020 and other key Olympic stakeholders."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"12-title halfScale\" src=\"/2019-20/static/_content/12-1-title-1.png\" style=\"top:174px; left: 54px;\">\n      <img class=\"12-title halfScale\" src=\"/2019-20/static/_content/12-1-sub-1.png\" style=\"top: 337px; left: 54px;\">\n\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 12-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 12-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 12-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg12Anim = new TimelineMax();\n        pg12Anim.staggerFromTo(cOf(\"12-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"12-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"12-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg12Anim.stop();\n        removePulse(\"12-arrows\")\n      }\n      ",
    "searchText": "12  IGF Anti-Doping Committee Keeping golf clean The IGF is committed to ensuring that its competitions, athletes and members safeguard the integrity of golf and to protecting clean athletes through the fight against doping. Anti-Doping Meetings and Events  The IGF Anti-Doping and Medical Project Manager attended the ICIC 2020 Conference on the implementation of the 2021  IGF ANTI-DOPING COMMITTEE  Anti-Doping Committee Members  DAVID GARLAND (EUROPEAN TOUR) DAVIDE LANTOS (LADIES EUROPEAN TOUR) MICHAEL LEE (UNITED STATES GOLF ASSOCIATION) ANDY LEVINSON (PGA TOUR) SHONA MCRAE (THE R&A) LIZ MOORE (LPGA) ANTONY SCANLON (IGF)  READ MORE  IGF Biennial Report 2019-20  World Anti-Doping Code in Vaals, Netherlands, from 15-17 January 2020.  The IGF Anti-Doping and Medical Project Manager participated in WADA’s Youth Olympic Games antidoping outreach programme on 8 January 2020 at the Olympic Village in Lausanne.  The IGF Anti-Doping Committee met by phone on 20 November 2019.  The IGF Executive Director and IGF Chief Medical Officer attended the WADA World Conference held in Katowice, Poland, on 4-6 November 2019.  The IGF Anti-Doping Project Manager attended the Institute"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg12Anim = new TimelineMax();\n        pg12Anim.fromTo(cOf(\"12-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"12-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg12Anim.stop();\n        removePulse(\"12-arrows\")\n      }\n      ",
    "searchText": "12  of National Anti-Doping Organisations (iNADO) Conference on 12 March 2019 in Lausanne and the WADA IF Symposium on 13-14 March 2019 in Lausanne with presentations on the proposed changes to the 2021 Code.  The IGF Professional Members’ Anti-Doping Workshop was held on 11 March 2019 at PGA TOUR HQ with 28 participating in the meeting.  WADA Relations  The IGF Executive Director and IGF Anti-Doping and Medical Project Manager met with WADA’s International Federation Relations Director on 30 September 2019.  The IGF Executive Director and IGF Chief Medical Officer represented the  IGF ANTI-DOPING COMMITTEE  IGF at WADA’s World Conference on Doping in Sport, which was held from 5-7 November 2019 in Katowice.  The IGF Anti-Doping and Medical Project Manager attended the Maison du Sport International (MSI)’s clean sport seminar on antidoping education, ‘Protecting the Next Generation’, on 12 November 2019 (organised in collaboration with WADA).  IGF Biennial Report 2019-20  International Testing Agency (ITA) Relations  The IGF Executive Director and IGF Anti-Doping and Medical Project Manager had a number of meetings throughout 2019 and 2020 with the ITA Director General and the ITA staff in preparation for the Olympic Games.  The 2021 World Anti-Doping Code and 2021 IGF Anti-Doping Policy  WADA has drafted a revised World Anti-Doping Code and International Standards that will come into effect on 1 January 2021. This 2021 Code, the relevant standards and a new Anti-Doping Charter of Athlete Rights were approved in Katowice in November 2019 and ended a"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"12-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg12Anim = new TimelineMax();\n        pg12Anim.fromTo(cOf(\"12-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"12-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg12Anim.stop();\n        removePulse(\"12-arrows\")\n      }\n      ",
    "searchText": "12  IGF ANTI-DOPING COMMITTEE  IGF Biennial Report 2019-20  Rebecca Kay of Australia, WATC 2018  two-year consultation process with IFs, including the IGF, and other stakeholders. The IGF has drafted its own 2021 Anti-Doping Policy for use in 2021 in line with the 2021 World Anti-Doping Code and eight mandatory International Standards for 2021 (results management, education, testing & investigations, therapeutic use exemptions, laboratory, code compliance by signatories, protection of privacy & personal information and the prohibited list).  The 2021 Prohibited List will contain the new category ‘Substances of Abuse’ which will be associated with more lenient sanctions,  the IGF’s Olympic anti-doping programme has been postponed by a year and will now be subject to the 2021 anti-doping rules. encouraging rehabilitation programmes when substances are taken out of competition with no intent of performance enhancement. ‘Recreational Athletes’, tested by anti-doping organisations, will also be subject to a more flexible and lenient sanctioning approach.  Olympic Games Tokyo 2020 Anti-Doping Programme  Due to the postponement of the Olympic Games Tokyo 2020,   The ITA will be carrying out many of the IOC’s anti-doping activities before and during the Olympic Games Tokyo 2020. The ITA PreGames Expert Group will provide recommendations to the IFs and ITA on testing gaps in the lead up to the Olympic Games. IOC and ITA samples will be analysed and stored in WADA-accredited laboratories and the hearings and decisions will be carried out by the Court of Arbitration for Sport Anti-Doping Division (CAS ADD)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"13-title halfScale\" src=\"/2019-20/static/_content/13-1-title-1.png\" style=\"top:144px; left: 54px;\">\n      <img class=\"13-title halfScale\" src=\"/2019-20/static/_content/13-1-sub-1.png\" style=\"top: 404px; left: 54px;\">\n\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 13-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 13-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 13-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.staggerFromTo(cOf(\"13-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"13-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"13-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop();\n        removePulse(\"13-arrows\")\n      }\n      ",
    "searchText": "13  IGF Golfers with Disabilities Committee & IPC Relations The IGF Golfers with Disabilities Committee is an advisory body appointed by the Board and established to advise on all matters related to golf for the disabled. The IGF is recognised by the International Paralympic Committee (IPC) as the IF for golf and is committed to the development of golf for the disabled. It promotes participation in and accessibility to golf for the disabled.  IGF GOLFERS WITH DISABILITIES COMMITTEE & IPC RELATIONS  IGF Biennial Report 2019-20  Golfers with Disabilities Committee Members TONY BENNETT CHAIR (IGF ADVISOR)  ROGER HAWKES (EDGA)  ANDY STUBBS (EUROPEAN TOUR)  KEVIN BARKER (THE R&A)  BETH MAJOR (UNITED STATES GOLF ASSOCIATION, 2019)  TOMMY TANGTIPHAIBOONTANA (UNITED STATES GOLF ASSOCIATION)  CHRISTIAN HAMILTON (GOLF AUSTRALIA)  DERRICK SHERIDAN (IBGA)  In 2019 and 2020, its activities included:  The creation of a pathway for all golfers with a disability to sample, take part and compete, from club level through to international events.  A poster campaign featuring seven different impairments READ MORE  is complete in 13 languages and is ready for dissemination. Training for therapists, first touch introducers and coaches is under development.  The World Ranking for Golfers with Disability (WR4GD) gathered momentum under the umbrella"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.fromTo(cOf(\"13-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"13-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop();\n        removePulse(\"13-arrows\")\n      }\n      ",
    "searchText": "13  IGF GOLFERS WITH DISABILITIES COMMITTEE & IPC RELATIONS  IGF Biennial Report 2019-20  Credit: EDGA  IPC Relations/Paralympic Games Paris 2024 bid  of the World Amateur Golf Ranking (WAGR). The number of tournaments grew, as did the number of players involved in the rankings, to over 800. The gross ranking enjoyed a 51  per cent increase in players, while a growth of 44 per cent and 34.1 per cent in the net and stableford rankings was also noted until the end of August 2019.   Attendance at the IPC General Assembly and Conference in Bonn, October 2019, confirmed that the IPC were permitted to have 23 sports take part in the Paris 2024 Paralympic Games, and that the IPC had decided that no further sports would be added to the 22 existing sports competing in the Paralympic Games Tokyo 2020.  Meetings took place with the Paralympic Games Sport and National Paralympic Committee Services Senior Manager and the IPC Medical and Scientific Director"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"13-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.fromTo(cOf(\"13-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"13-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop();\n        removePulse(\"13-arrows\")\n      }\n      ",
    "searchText": "IGF GOLFERS WITH DISABILITIES COMMITTEE & IPC RELATIONS  Credit: EDGA  13  regarding the feedback received from the IGF’s Paralympic Games Paris 2024 application, and initial discussions took place on what may be in store for a 2028 application.  The Golfers with Disabilities Committee will commence the development of a structured bid strategy at the 2020 meeting, ahead of presenting this to the Board.  Establish and manage an international eligibility and classification system for Golfers with Disability (GwD)  In March 2020, a consensus meeting of 23 participants from 14 countries was the culmination of several months of online work to construct a robust eligibility and classification standard for GwD.  The development of an enhanced training provision for eligibility assessors has been ongoing through 2019 and early 2020 and together with the European Disabled Golf Association (EDGA) and the Shirley Ryan Ability Lab progress  IGF Biennial Report 2019-20  has been made towards a world standard.  World Rankings for Golfers with a Disability (WR4GD)  After a period of consultation, in November 2018, responsibility for calculating the WR4GD was agreed to be transferred from EDGA to WAGR from 1 January 2019. The Golfers with Disabilities Committee had been fully informed of the initial development of the Ranking by EDGA, along with the process of transition. The Ranking is open to all golfers with a disability who possess a WR4GD pass, and a nationallyrecognised golf handicap."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"14-title halfScale\" src=\"/2019-20/static/_content/14-1-title-1.png\" style=\"top:144px; left: 54px;\">\n      <img class=\"14-title halfScale\" src=\"/2019-20/static/_content/14-1-sub-1.png\" style=\"top: 213px; left: 55px;\">\n\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 14-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 14-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 14-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.staggerFromTo(cOf(\"14-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"14-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"14-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg14Anim.stop();\n        removePulse(\"14-arrows\")\n      }\n      ",
    "searchText": "14  SUSTAINABILITY  Sustainability  IOC on 18 September 2019 at the IOC’s Olympic Museum.  Golf is a sports leader in sustainable practices and providing social and environmental benefits. The IGF represents golf at a number of environmental international non-government organisations and forums promoting the sustainable actions of its member organisations. Inter national Union for Conservation of Nature (IUCN) guide on urban biodiversity and sports  examples from golf in North America and Europe and is expected to be published towards the end of 2020 or the beginning of 2021.   The IGF has provided golf-specific input to the IUCN and the San Francisco Estuary Institute for the ICUN’s upcoming guide on urban biodiversity and sports, which will be part of a series of IUCN guides on sustainability in sports.  IOC/United Nations Framework Convention on Climate Change (UNFCCC) Sports for Climate Change Framework   This IUCN guide will contain  IGF Biennial Report 2019-20   The IGF Executive Director attended the Sports for Climate Change Framework Meeting organised by the United Nations (UN) and the READ MORE   The Sport Positive Summit, which brings together global sports and environment stakeholders and holds the annual meeting organised by the UN for the Framework’s signatories, was initially scheduled for March 2020 in London and has been rescheduled for October 2020."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.fromTo(cOf(\"14-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"14-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg14Anim.stop();\n        removePulse(\"14-arrows\")\n      }\n      ",
    "searchText": "14  SUSTAINABILITY  IGF Biennial Report 2019-20  4. Promote sustainable and responsible consumption 5. Advocate for climate action through communication   Climate-related risks to health, livelihoods, food security, water supply, human security, and economic growth are projected to increase with global warming of 1.5°C. The UN has created a new climate action for sport movement with the IOC’s guidance for sports organisations to work together in the climate neutrality journey.   The UN invited IFs to be a part of Sports for Climate Action through five principles: 1. Undertake systematic efforts to promote greater environmental responsibility 2. Reduce overall climate impact 3. Educate for climate action   After carefully assessing the UN’s framework with the IOC and the Golf Environment Organization (GEO), the IGF Executive Director signed a letter of intent to implement the principles in the Sports for Climate Action Framework on 22 August 2019. Through this action, the IGF showed its support to the Framework, and was able to express an interest the following month in being part of the working groups, which are being created by the UN and the IOC to"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"14-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.fromTo(cOf(\"14-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"14-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg14Anim.stop();\n        removePulse(\"14-arrows\")\n      }\n      ",
    "searchText": "14  IGF Biennial Report 2019-20  SUSTAINABILITY  CERTIFICATE e The International Olympic Committe and Dow have recognised  define the future approach in sport, as well as being eligible to apply for the IOC-Dow Carbon Initiative.  Based on the calculations using the UN carbon footprint calculator recommended by the IOC in its Sustainability Essentials Sports for Climate Action, the IGF’s carbon footprint is 181 tonnes/year for 2019.  The IGF will readjust the scope of the IGF footprint and recalculate on a yearly basis, continue to track the IGF’s emissions, aim to reduce these emissions and compensate (offset) unavoidable emissions with the support of the IOC.  (IGF) International Golf Federation  reduce owned for their actions to measure and and for joining the greenhouse gas (GHG) emissions Action Framework. United Nations Sports for Climate have been fully The unavoidable 2019 GHG emissions Partnership through offset by the IOC – Dow Carbon GHG projects. a portfolio of ICROA-compliant  Jim Fitterling Dow Chief Executive Officer  Thomas Bach IOC President   The IOC and Dow awarded the IGF with carbon credits to offset its 2019 carbon footprint at the IF Forum Sustainability Session in October 2019.  Lausanne, 30 October 2019  UN Clean Seas Campaign  The Clean Seas campaign was launched by UN Environment with the aim of engaging governments, the general public, civil society and the private sector in the fight against marine plastic litter. The IGF became a member at the end of 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      <img class=\"15-title halfScale\" src=\"/2019-20/static/_content/15-1-title-1.png\" style=\"top:144px; left: 54px;\">\n      <img class=\"15-title halfScale\" src=\"/2019-20/static/_content/15-1-sub-1.png\" style=\"top: 208px; left: 55px;\">\n\n      <img class=\"15-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"15-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg15Anim = new TimelineMax();\n        pg15Anim.staggerFromTo(cOf(\"15-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"15-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"15-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg15Anim.stop();\n        removePulse(\"15-arrows\")\n      }\n      ",
    "searchText": "15  IOC Relations The IGF has forged a strong partnership with the IOC and continues to work closely with their staff and that of the Organising Committees for the Olympic Games.  IOC RELATIONS   The Executive Director was reappointed by the IOC President to the IOC Digital and Technology Commission, which has been created to advise the IOC Session, the IOC Executive Board and the IOC President on issues relating to the effective and secure use of digital and information technologies. He has attended every Commission meeting that has been held.  The IGF holds regular meetings with the IOC Director of Sport, the IOC Olympic Games Executive Director, and other Directors and staff at the IOC on mutual matters concerning the Olympic Games and the Olympic Movement.   The Executive Director attended the 133rd IOC Session held in Buenos Aires, Argentina, from 8 to 9 October 2018, prior to the Youth Olympic Games Buenos Aires 2018.  More specifically, during 2019 and 2020 the relationship between the IOC and the IGF has been further strengthened through the following activities:   The IGF President and the Executive Director also attended the historic 134th IOC Session in Lausanne, which also coincided with the opening of the IOC’s new Olympic  IGF Biennial Report 2019-20  House headquarters on 23 June 2019. During this session the 2024 and 2028 Olympic Games were simultaneously awarded to Paris and Los Angeles respectively, and golf’s place at the Olympic Games Paris 2024 was also confirmed.  The Executive Director attended the 135th IOC Session held in Lausanne on 10 January 2020, prior to the Winter Youth Olympic Games Lausanne 2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"16-title halfScale\" src=\"/2019-20/static/_content/16-title-1.png\" style=\"top:174px; left: 54px;\">\n      <img class=\"16-title halfScale\" src=\"/2019-20/static/_content/16-sub-1.png\" style=\"top: 258px; left: 55px;\">\n\n      <img class=\"16-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"16-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg16Anim = new TimelineMax();\n        pg16Anim.staggerFromTo(cOf(\"16-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"16-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"16-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg16Anim.stop();\n        removePulse(\"16-arrows\")\n      }\n      ",
    "searchText": "16  ASOIF RELATIONS  IGF Biennial Report 2019-20  ASOIF Relations The IGF is an active and influential member of the Association of Summer Olympic International Federations (ASOIF), which aims to unite, promote and support all of the International Summer Olympic Federations, while also representing them on issues of common interest in the Summer Olympic Games and the Olympic Movement. The IGF Executive Director holds regular meetings with the ASOIF Executive Director and the ASOIF President, and is a member of the ASOIF Olympic and Multisport Games Advisory Group (OMGA) and Chair of the ASOIF Commercial Advisory Group (CAG). He also attended the ASOIF General Assembly held on 3 May 2019 at the Gold Coast, Australia. The 2020 ASOIF General Assembly has been postponed until November 2020.  Shannon McWilliam of Scotland, WATC 2018"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      <img class=\"17-title halfScale\" src=\"/2019-20/static/_content/17-title-1.png\" style=\"top:327px; left: 56px;\">\n\n      <img class=\"17-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"17-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg17Anim = new TimelineMax();\n        pg17Anim.staggerFromTo(cOf(\"17-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"17-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"17-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg17Anim.stop();\n        removePulse(\"17-arrows\")\n      }\n      ",
    "searchText": "17  GAISF Relations The Global Association of International Sports Federations (GAISF) is an umbrella body composed of autonomous and independent IFs and other international sport and event-related organisations. The IGF continues to be an active member of this organisation and attended its General Assembly on 6 May 2019 at the Gold Coast. The 2020 GAISF General Assembly has been postponed and a date for it is yet to be determined.  GAISF RELATIONS  IGF Biennial Report 2019-20  Jimmy Zheng of New Zealand, YOG 2018"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <img class=\"18-title halfScale\" src=\"/2019-20/static/_content/18-title-1.png\" style=\"top:417px; left: 56px;\">\n      <img class=\"18-title halfScale\" src=\"/2019-20/static/_content/18-sub-1.png\" style=\"top:540px; left: 55px;\">\n\n      <h1 class=\"abs calibriBI 18-no\" style=\"left:772px;top:284px; font-size: 5.4em; font-weight:700; margin:0; color:#b4975a;\"  data-number='{\"to\": 151}' ></h1>\n\n      <img class=\"18-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"18-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg18Anim = new TimelineMax();\n        pg18Anim.staggerFromTo(cOf(\"18-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"18-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"18-no\")[0]);\n        }},\"-=0.2\")\n        .fromTo(cOf(\"18-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"18-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg18Anim.stop();\n        removePulse(\"18-arrows\");\n        resetNumbers(\"18-no\");\n      }\n      ",
    "searchText": "18  IGF Biennial Report 2019-20  NATIONAL FEDERATION MEMBERS  IGF has  151  National Federation Members The IGF member organisations continue to reach golfers around the world. The IGF recognises 151 National Federation members from 146 National Olympic Committees, in addition to 22 professional golf organisations that have been granted Professional membership.  National Federation Members"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"19-title halfScale\" src=\"/2019-20/static/_content/19-1-title-1.png\" style=\"top:296px; left: 455px;\">\n      <img class=\"19-title halfScale\" src=\"/2019-20/static/_content/19-1-sub-1.png\" style=\"top: 367px; left: 455px;\">\n      <img class=\"19-img halfScaleC\" src=\"/2019-20/static/_content/19-1-img-1.png\" style=\"top: 104px; left: 898px;\">\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 19-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 19-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 19-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  WATC IRELAND 2018  IGF Biennial Report 2019-20  WATC IRELAND ’18  WATC Ireland 2018 The 2018 WATC saw the first staging of this iconic event in Ireland since the championship was first played in 1958, with the hosts, the Irish Ladies’ Golf Union (ILGU) and the Golfing Union of Ireland (GUI) delivering wonderful and memorable championships. The IGF is extremely thankful to both host organisations staff and the volunteers who worked tirelessly to ensure the WATC’s success. All left impressed with the dedication, friendliness and warmth of the team. A record number of 58 entries for the Espirito Santo Trophy competition for women and 71 entries for the  Eisenhower Trophy competition for men played at the O’Meara and Montgomerie Courses at the Carton House estate in County Kildare.  Espirito Santo Trophy – USA wins first Espirito Santo Trophy in 20 years USA won the Women’s WATC with a READ MORE  flourish to lift the Espirito Santo Trophy for the 14th time. Bolstered by nearly perfect scoring conditions and the performances of Kristen Gillman – who won the US Women’s Amateur Championship in 2016 and 2018 – and McCormack medal winner Jennifer Kupcho, USA eased to a 10-stroke victory over"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  WATC IRELAND 2018  IGF Biennial Report 2019-20  Kristen Gillman, Jennifer Kupcho, Lilia Vu and Stasia Collins of USA (gold medallists), WATC 2018  Japan on the O’Meara Course for its first gold since 1998 in Chile. “I am so proud of these girls,” said American captain Stasia Collins. “I am so proud of this team, and I am really happy for them and thrilled for the United States. They will always Kristen Gillman of USA (gold medallist), WATC 2018  be known as the gold medal winners for the 2018 World Amateur Team Championships – [nobody] can take that away from us.” USA, in winning its first medal since Argentina in 2010, posted a 29-underpar 551. Gillman was the driving force of the day, making an eagle and four birdies against one bogey in her first nine holes to make the turn at 5-under. She added a birdie on the 13th en route to a 6-under 67. Kupcho fired a 4-under-69 to give USA a 10-under fourth-round total of 136. She and Gillman were also members  of USA’s victorious Curtis Cup Team in June. “We have the strong bond already from the beginning, especially yesterday when we were all struggling, we all fought for each other,” said Kupcho, who won the NCAA Women’s individual title in 2018. “We all wanted to win for each other, and I think that was a big thing coming out of yesterday."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  WATC IRELAND 2018  IGF Biennial Report 2019-20  Yuri Yoshida of Japan (silver medallist), WATC 2018  who had won three of the previous four WATCs, withstood a late rally from fourth-place the People’s Republic of China to finish at 18-under 562. Although there is no official recognition, the Republic of Korea’s Ayean Cho was the lowest individual scorer at 19-under 273.  And I think that’s how we got our big lead coming into today.”  19-under 561. Japan’s previous best finish was fourth in 1984.  Japan’s first appearance on the medal podium in 28 appearances was formulated by a pair of 3-under 70s from 18-year-olds Yuri Yoshida and Yuna Nishimura. Their final total was  Defending champion, the Republic of Korea, stalled in its attempt to overtake USA and captured the bronze medal, which is its fifth consecutive medalwinning performance. The Koreans,  Seoyeon Kwon of Republic of Korea (bronze medallist), WATC 2018"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-4.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  WATC IRELAND 2018  IGF Biennial Report 2019-20  Torben Henriksen Nyehuus, John Axelsen, Nicolai Hojgaard, and Rasmus Hojgaard of Denmark (gold medallists), WAC 2018  Eisenhower Trophy – Denmark Wins First Eisenhower Trophy Denmark, bolstered by the stellar play of 19-year-old identical twins Nicolai and Rasmus Hojgaard, held off a surging field to win its first Men’s WATC at 39-under-par 541 by one stroke over USA. The Danes claimed the Eisenhower Trophy in their 25th appearance as Nicolai Hojgaard, the 2018 European Amateur champion, posted a 7-underpar 66 and his brother Rasmus fired a 6-under-par 67 for a team total of 13-under-par 133 on the par-73 O’Meara Course. Teammate John Axelsen posted a non-counting 4-under  69. Denmark had previously claimed the silver medal in 2010.  in second, so this is just amazing. It’s pretty nice to go one better.”  “It means a lot,” said six-time Danish captain Torben Nyehuus. “Everybody is watching. It’s just amazing. I was with the team in 2010 when we came  Nicolai notched five birdies in his final nine holes and Rasmus logged three as they took the lead in a tightly-packed leaderboard. Four teams – Denmark,"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-5.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  IGF Biennial Report 2019-20  WATC IRELAND 2018  Justin Suh of USA (silver medallist), WATC 2018  USA, Spain and New Zealand – were tied at 34-under as the last groups made the turn.  To medal in my first international competition, especially on a stage as big as this, is really special.”  “I feel wonderful,” said Nicolai. “This is a dream come true for all of us. I had a tough start to this tournament, so I was just trying to play some good rounds to help the team. I did that the last two rounds so this is perfect. This is the biggest team event we could have won and to do it with Rasmus is perfect. But, also with John. John is a great friend and we are all having fun. This is just wonderful.”  (7-under-par 66) and University of Southern California senior Justin Suh (4-under-par 69) to pass Spain for the silver medal at 38-under-par 542.  Spain took the bronze medal at 36-under-par 544. New Zealand, which held the lead through 36 and 54 holes, was fourth at 545, followed by Norway, Italy and Thailand tied for fifth at 548, England in eighth at 549, Canada in ninth at 550 and host Ireland and Germany tied for 10th at 553.  “It says a lot,” said Hammer, who was also the 2018 US Amateur Four-Ball champion. “It speaks a lot to the way our team jelled and how much fun we had together. When you are having fun playing golf, good things happen.  Although there is no official recognition, Spain’s Alejandro “Alex” Del Rey was the lowest individual scorer at 23-underpar 267. He and England’s Matthew Jordan shot the low scores in the fourth round at 8-under-par 65.  USA used a strong finish by University of Texas freshman and 2018 US Amateur semi-finalist Cole Hammer"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19-6.jpg",
    "zoom": null,
    "content": "\n      <img class=\"19-title halfScale\" src=\"/2019-20/static/_content/19-6-title-1.png\" style=\"top:131px; left: 76px;\">\n      <img class=\"19-title halfScale\" src=\"/2019-20/static/_content/19-6-title-2.png\" style=\"top: 131px; left: 665px;\">\n\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"19-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"19-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"19-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"19-arrows\")\n      }\n      ",
    "searchText": "19  WATC IRELAND 2018  2018 Espirito Santo Trophy Facts  2018 Eisenhower Trophy Facts  (14 gold, three silver and three  in 1992 with a four-player team of Phillip Colombia’s Esteban Restrepo scored  Tataurangi, Michael Campbell, Stephen  and Kupcho fired 8-under 65s  the first hole-in-one at the Eisenhower  Scahill and Gordon Moorheard that  on the O’Meara Course in round  Trophy since 2010 on the par-3 seventh  broke the WATC scoring record by  USA took the lead when Gillman  bronze).  IGF Biennial Report 2019-20  two and went from a one-stroke  The Republic of Korea has won eight  hole of the O’Meara Course using an  11 strokes with an 823. At that time,  lead through 36 holes to a five-  medals (four gold, two silver and  8-iron. He was 3-under on the tee  three scores of four counted and the  stroke lead through 54 holes to  two bronze).  and finished with a round of 5-under-  previous mark was 834 set by USA in  par 68. Teammate Ivan Camilo Ramirez  1960 with a team that included Jack  Velandia added a 4-under-par 68 and  Nicklaus. USA finished second that  Juyun ‘Birdie’ Kim, captain of the  they posted a 9-under-par 137 to move  year with two Major winners on the  For the second consecutive day, the  Republic of Korea team, won the  up to 18th place.  team – Justin Leonard (1997 Open) and  Norwegian duo of Renate Hjelle  2005 US Women’s Open.  a 10-stroke victory.  David Duval (2001 Open). Tataurangi and Campbell finished one-two in the  Grimstad (67) and Karoline Stormo (70) forged another strong move up  Denmark’s identical twins Rasmus and  individual scoring.  the leaderboard with a two-score total  Beatriz Arenas, 70, of Guatemala was  Nicolai Hojgaard had identical 9-under  of 7-under 137 on the Montgomerie  the oldest player in the field. This was  par scores of 208 through 54 holes.  Course. Over the last two rounds,  her eighth time as a player and third  USA won its 26th medal (15 gold,  Norway moved from T33 to T12 and  as a captain.  nine silver and two bronze).  then to 10th. Their 130-137 finish in  The last one-stroke margin of victory  the last two rounds was 267, 13  was in 1968 when USA prevailed over  under par.  Lebanon made its first appearance  Great Britain and Ireland (868-869)  Spain won its fourth overall medal and  in the Espirito Santo Trophy while  in Australia.  first since a bronze medal finish in 2014.  New Zealand was vying for its first  Defending champion Australia  medal (fifth overall) since it won gold  finished T12.  Bulgaria made its second appearance. USA has won 20 total medals in the Espirito Santo Trophy competition"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-1-title-1.png\" style=\"top:266px; left: 209px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-1-sub-1.png\" style=\"top: 337px; left: 209px;\">\n      <img class=\"20-img halfScaleC\" src=\"/2019-20/static/_content/20-1-img-1.png\" style=\"top: 188px; left: -3px;\">\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow-white.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 20-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 20-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 20-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg20Anim = new TimelineMax();\n        pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg20Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  YOG BUENOS AIRES 2018  IGF Biennial Report 2019-20  Karl Vilips of Australia (gold medallist), YOG 2018  Australia strike golden double Grace Kim and Karl Vilips, from Australia, were crowned Youth Olympic Games champions while Thailand won the mixed team event in a thrilling conclusion at the historic Hurlingham Club in Buenos Aires. After a spectacular debut in Nanjing, the People’s Republic of China, in 2014, golf was once again on the sports programme for the third edition of the Youth Olympic Games (YOG) held in Buenos Aires in October 2018. The Argentine capital’s historic Hurlingham Club welcomed 64 of the finest junior golfers from around the world for three events – the men’s and  women’s individual 54-hole stroke play tournaments and the 72-hole mixed gender team event. The women’s field included the likes of 16-year-old Lucy Li, of the USA, who at the age of just 11 became the youngest ever player to appear in the US Women’s Open and entered the Youth Olympic Games in the top 10 of the World Amateur Golf Rankings. READ MORE  Also teeing it up were Thailand’s Atthaya Thitikul who in 201 became the youngest ever winner on the Ladies European Tour when she won the Ladies European Thailand"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  YOG BUENOS AIRES 2018  IGF Biennial Report 2020-20  Emma Spitz of Austria (bronze medallist), YOG 2018  Championship at the age of just 14 Yuka Saso of the Philippines, who arrived in Buenos Aires off the back of winning two gold medals at the Asian Games, and three members of the European 2018 Junior Ryder Cup team Emma Spit (Austria), Alessia Nobilio (Italy) and Amanda Linner (Sweden). It was 16-year-old Nobilio who set the early pace, with her two-under-par opening-round 68 giving her an early three-stroke lead over a group of five players that included Saso and Kim. The following day saw Kim get off to a flying start with three birdies in her opening four holes. The Australian  eventually signed for a 69, making her the only player able to break par in the windy conditions and moving her level with Nobilio at the top of the leaderboard following the Italian’s 2.  The Italian then dropped four shots over the next four holes, while Kim bounced back with birdies at the fifth, 11th and 16th to secure the gold medal by three strokes.  In contrast to her fast start on day two, the final round saw Kim bogey two of the opening four holes, with Nobilio taking the lead after a birdie on the fifth.  Nobilio’s 4 dropped her into a threeway tie with Spit and Saso, whose final-round 69 was the lowest score of the day. In the ensuing sudden-"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  death play-off for the silver and bron e medals, Nobilio birdied the par-4 first to claim second place, with Spit parring the hole to take the bron e, while the unlucky Saso’s bogey saw her miss out on the podium. The men’s event featured a similarly impressive field, including the likes of Eisenhower Cup winner Nicolai Hoejgaard of Denmark and USA’s Akshay Bhatia, who was a member of the successful 2018 USA Junior Ryder Cup team and the first player ever to win back-to-back Boys Junior PGA Championship titles. Bhatia’s pedigree showed during the opening round, as his 69 left him in a four-way tie at the top of the leaderboard alongside Thailand’s Vanchai Luangnitikul, Italy’s Andrea  YOG BUENOS AIRES 2018  Romano and Vilips, who birdied three of the final five holes in his 69. Vilips picked up where he left off in round two, with birdies at the second, fourth, seventh and 1 th holes helping him to a two-under 68 and a one-stroke lead over Bhatia, who shot a second successive 69. The American took control in wet conditions in the final round, moving into a three-stroke lead with just six holes to play, but the left-hander’s double-bogey at the 14th opened the door for Vilips, who birdied four of the final six holes to shoot 69 and clinch a golden double for Australia. Bhatia’s 0 meant he secured silver, two strokes behind Vilips, while Jerry Ji of the Netherlands shot a closing 68 to clinch bron e.  IGF Biennial Report 2020-20  Akshay Bhatia of USA (silver medallist), YOG 2018"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-4.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  YOG BUENOS AIRES 2018  IGF Biennial Report 2020-20  they combined for a 68, giving them a one-stroke advantage over the Italian duo heading into the final day’s play.  Mateo Fernández de Oliveira and Ela Anacona of Argentina (bronze medallists), Atthaya Thitikul and Vanchai Luangnitikul of Thailand (gold medallists), and Akshay Bhatia and Lucy Li of USA (silver medallists), YOG 2018  After their individual golds, Vilips and Kim were firm favourites to triumph in the mixed team event, but it was Italy’s Nobilio and Romano who stole the show in the opening round, firing nine birdies and an eagle in their better-ball  5 , which also included a spectacular hole-in-one for Romano at the ninth. The second-round foursomes then saw Thailand’s Thitikul and Luangnitikul move to the top of the leaderboard as  With both players’ scores counting towards the team total in the final round, there was plenty of drama in the chase for the medals. Spurred on by the support of the home crowd, Argentine duo Mateo Fern nde de Oliveira and Ela Anacona finished seven-under-par to seal bron e, but a superb 66 from Bhatia and a 71 for Li looked to have secured gold for USA as they moved five shots clear of the Thai pairing with just three holes to play. But two closing birdies from Thitikul saw her and Luangnitikul leapfrog the Americans on to the top of the podium, bringing the Buenos Aires 2018 golf events to a thrilling conclusion."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-title-1.png\" style=\"top:145px; left: 55px;\">\n      <img class=\"20-title\" src=\"/2019-20/static/_content/up-arrow-green.png\" style=\"top: 612px; left: 226px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-sub-1.png\" style=\"top: 641px; left: 57px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-sub-2.png\" style=\"top: 158px; left: 473px;\">\n      <img class=\"20-title\" src=\"/2019-20/static/_content/down-arrow-green.png\" style=\"top:329px; left: 628px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-sub-3.png\" style=\"top: 160px; left: 898px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-sub-4.png\" style=\"top: 361px; left: 901px;\">\n      <img class=\"20-title halfScale\" src=\"/2019-20/static/_content/20-5-sub-5.png\" style=\"top: 661px; left: 902px;\">\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  What they said…  YOG BUENOS AIRES 2018  IGF Biennial Report 2020-20  “That was amazing, I’m blown away! It’s so special to win an Olympic medal.”  “It’s been one of the best tournaments I’ve ever played in.”  GRACE KIM (AUSTRALIA),  MATEO FERNÁNDEZ DE OLIVEIRA (ARGENTINA), MI ED TEAM BRON E MEDALLIST  WOMEN’S INDIVIDUAL GOLD MEDALLIST  “It’s such an honour to represent my country in the Youth Olympic Games and words cannot describe anything now; I’m just so happy.”  “I never thought I could achieve something like this. It’s a dream come true to have done what I’ve done here.” KARL VILIPS (AUSTRALIA), MEN’S INDIVIDUAL GOLD MEDALLIST  ATTHAYA THITIKUL (THAILAND), MI ED TEAM GOLD MEDALLIST  “I had an amazing experience this week; it was incredible.” LUCY LI (USA), MI ED TEAM SILVER MEDALLIST"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-6.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow-white.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow-white.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  YOG BUENOS AIRES 2018  IGF Biennial Report 2020-20  Did you know?  32  32 men and 32 women from 33 countries  -12  The winning score of Thailand’s Atthaya Thitikul and Vanchai Luangnitikul in the mixed team event  1  Andrea Romano, of Italy, hit a hole-in-one on the ninth hole of the opening round of the mixed team event  68  The lowest round recorded in the men’s tournament, shot by arl Vilips (round two), Ryo Hisatsune (round two), Václav Tich (round three) and erry i (round three)  57  Italian pair Alessia Nobilio and Andrea Romano combined to shoot a better-ball 57 in the opening round of the mixed team event – the lowest score of the tournament  68  Alessia Nobilio’s opening-round 68 was the lowest score in the women’s tournament  2  USA’s Akshay Bhatia was the only player to win two medals, winning silver in both the men’s tournament and the mixed team event"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20-7.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"20-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg19Anim = new TimelineMax();\n        pg19Anim.staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"20-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"20-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg19Anim.stop();\n        removePulse(\"20-arrows\")\n      }\n      ",
    "searchText": "20  YOG BUENOS AIRES 2018  IGF Biennial Report 2019-20  Participating National Olympic Committees (NOCs) Results Thirty-three NOCs from five continents participated in the golf competitions. AFRICA 2  ASIA 8  AMERICAS 4  EUROPE 16  OCEANIA 3  Nigeria  Chinese Taipei  Argentina  Austria  Australia  South Africa  Indonesia  Canada  Belgium  New ealand  Japan  Mexico  C ech Republic  Papua New Guinea  People’s Republic of China  USA  Denmark  Philippines  Finland  Republic of Korea  France  Thailand  Germany  United Arab Emirates  Great Britain  Men’s event  Gold: Karl Vilips (Australia) Silver: Akshay Bhatia (USA) Bronze: Jerry Ji (Netherlands)  Women’s event Gold: Grace Kim (Australia) Silver: Alessia Nobilio (Italy) Bronze: Emma Spitz (Austria)  Iceland Ireland Italy Netherlands Norway Spain Sweden Swit erland  Mixed team event Gold: Atthaya Thitikul and Vanchai Luangnitikul (Thailand) Silver: Lucy Li and Akshay Bhatia (USA) Bronze: Ela Anacona and Mateo Fernández de Oliveira (Argentina)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-1-title-1.png\" style=\"top:326px; left: 455px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-1-sub-1.png\" style=\"top: 458px; left: 455px;\">\n      <img class=\"21-img halfScaleC\" src=\"/2019-20/static/_content/21-1-img-1.png\" style=\"top: 64px; left: 405px;\">\n\n      <img class=\"21-arrows pointer\" src=\"/2019-20/static/_content/left-arrow-white.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"21-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 21-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 21-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 21-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg21Anim = new TimelineMax();\n        pg21Anim.staggerFromTo(cOf(\"21-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"21-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6)\n        .fromTo(cOf(\"21-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"21-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg21Anim.stop();\n        removePulse(\"21-arrows\")\n      }\n      ",
    "searchText": "21  OLYMPIC GAMES TOKYO 2020  IGF Biennial Report 2019-20  any necessary amendments to the delivery of the Olympic golf competition, while keeping a clear focus on athletes and sport.  Olympic Games Tokyo 2020  Credit: Koji Aoki/AFLO  Tokyo 2020 to be the light at the end of the tunnel in 2021.  10th hole, East Course, Kasumigaseki Country Club  Due to the postponement of the Olympic Games Tokyo 2020 to 2021, efforts are being made across the Olympic Movement to explore opportunities to optimise Games preparation and delivery. The IGF is collaborating closely with the Tokyo 2020 Organising Committee and the IOC to identify ways and means to do this and to agree with all parties on READ MORE  As the Games will take place on the same dates in 2021, with one day difference, a number of operational elements can be easily adapted, for example, the competition schedule, the agronomy maintenance plan for the golf course and the Olympic Golf Regulations which determine the official rules for competition. The IGF and the Tokyo 2020 Organising Committee continue to advance on planning, making the necessary adjustments to cater for the change in date. In terms of the Qualification System, following the IOC’s postponement of the Olympic Games and its subsequent release of the revised principles"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-title-1.png\" style=\"top:175px; left: 533px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-sub-1.png\" style=\"top: 278px; left: 513px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-sub-2.png\" style=\"top: 351px; left: 484px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-sub-3.png\" style=\"top: 504px; left: 477px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-sub-4.png\" style=\"top: 605px; left: 503px;\">\n      <img class=\"21-title halfScale\" src=\"/2019-20/static/_content/21-2-sub-5.png\" style=\"top: 729px; left: 510px;\">\n\n      <h1 class=\"abs calibriBI 18-no\" style=\"left:614px;top:335px; font-size: 5.6em; font-weight:700; margin:0; color:#2e99d6;\"  data-number='{\"to\": 2}' ></h1>\n      <h1 class=\"abs calibriBI 18-no\" style=\"left:619px;top:618px; font-size: 2.1em; font-weight:700; margin:0; color:#2e99d6;\"  data-number='{\"to\": 72}' ></h1>\n      <h1 class=\"abs calibriBI 18-no\" style=\"left:516px;top:747px; font-size: 2.1em; font-weight:700; margin:0; color:#2e99d6;\"  data-number='{\"to\": 120}' ></h1>\n      <h1 class=\"abs calibriBI 18-no\" style=\"left:715px;top:747px; font-size: 2.1em; font-weight:700; margin:0; color:#2e99d6;\"  data-number='{\"to\": 40}' ></h1>\n\n      <img class=\"21-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"21-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg21Anim = new TimelineMax();\n        pg21Anim.staggerFromTo(cOf(\"21-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"18-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"18-no\")[0]);\n        }},2)\n        .fromTo(cOf(\"18-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"18-no\")[1]);\n        }},2.8)\n        .fromTo(cOf(\"18-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"18-no\")[2]);\n        }},3)\n        .fromTo(cOf(\"18-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"18-no\")[3]);\n        }},3.1)\n        .fromTo(cOf(\"21-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"21-arrows\")}, 1)\n      }\n\n      function onPageLeave() {\n        pg21Anim.stop();\n        removePulse(\"21-arrows\")\n      }\n      ",
    "searchText": "21  for Olympic qualification on 2 April 2020, which included the relaxation of the maximum two-year period and amendments to the qualification deadlines, the IGF revised the dates within the current qualification system to reflect these new timelines. The revised version was approved by the IOC Qualification taskforce and officially released on 29 April 2020. Athletes now will accumulate Olympic Golf Rankings (OGR) points through a period ending on 21 June 2021 for the men and 28 June 2021 for the women. The field for both men and women remains at 60 players. The OGR is based on the Official World Golf Ranking (OWGR) for men and the Women’s World Golf Rankings (WWGR). On 20 March 2020, the Governing Boards of the OWGR and WWGR determined the rankings would be suspended due to the COVID-19  OLYMPIC GAMES TOKYO 2020  Tokyo 2020 in Numbers 23 July - 8 August 2021  2  GOLF EVENTS Women’s event 4-7 August 2021  Men’s event 29 July – 1 August 2021  72  Holes of individual stroke play  120  Golfers  Approx.  40  NOCs  IGF Biennial Report 2019-20  pandemic. Upon the resumption of each respective ranking, the OGR will be updated and reflected accordingly. It goes without saying that the top priority remains first and foremost the health and safety of athletes, spectators, volunteers, staff and other stakeholders and that the inherent uncertainty around the world-wide evolution of the pandemic is forcing all parties to be flexible and agile in the re-planning of their activities. Tokyo 2020’s official Games motto, “United by Emotion”, emphasises the power of sport to bring together people from diverse backgrounds to connect and celebrate in a way that reaches beyond their differences. The IGF looks forward to the celebration and the coming together with all nations in Tokyo 2020 for another successful Olympic golf competition in 2021."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <img class=\"22-title halfScale\" src=\"/2019-20/static/_content/22-title-1.png\" style=\"top:266px; left: 55px;\">\n      <img class=\"22-img halfScaleC\" src=\"/2019-20/static/_content/22-img-1.png\" style=\"top: 121px; left: -88px;\">\n\n      <img class=\"22-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"22-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg22Anim = new TimelineMax();\n        pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"22-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n        .fromTo(cOf(\"22-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"22-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg22Anim.stop();\n        removePulse(\"22-arrows\")\n      }\n      ",
    "searchText": "22  WATC SINGAPORE 2020  IGF Biennial Report 2019-20  WATC Singapore 2020 In January 2020, the Administrative Committee determined that it was in the best interests of the 2020 WATC to relocate the staging of the event from Hong Kong to Singapore in order to allay the membership’s concerns on the social unrest that was occurring in Hong Kong at the time and to remove uncertainty about the staging of the event. However, the COVID-19 pandemic has affected all areas of society, including golf, significantly. Given that our highest priority is to safeguard the health and  Collin Morikawa of USA (silver medallist), WATC 2018  John Murphy and Robin Dawson of Ireland, WATC 2018  safety of all athletes, officials and volunteers at the 2020 WATC, and relying on the advice of the World Health Organisation (WHO) concerning the organisation of mass gatherings and events, the Administrative Committee regretfully decided to cancel the 2020 WATC.  to acknowledge the outstanding planning and preparations undertaken by both the Hong Kong Golf Association (HKGA) and the Singapore Golf Association (SGA), and believes that without the unfortunate turn of events both Associations would have delivered highly successful championships and a memorable experience for all participants.  The Administrative Committee wishes"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <img class=\"23-title halfScale\" src=\"/2019-20/static/_content/23-1-title-1.png\" style=\"top:206px; left: 55px;\">\n      <img class=\"23-title halfScale\" src=\"/2019-20/static/_content/23-1-sub-1.png\" style=\"top:330px; left: 908px;\">\n      <img class=\"23-title halfScale\" src=\"/2019-20/static/_content/23-1-sub-2.png\" style=\"top:796px; left: 909px;\">\n      <img class=\"23-img halfScaleC\" src=\"/2019-20/static/_content/23-1-img-1.png\" style=\"top: 130px; left: 513px;\">\n      <img class=\"23-img halfScaleC\" src=\"/2019-20/static/_content/23-1-img-2.png\" style=\"top: 565px; left: 1004px;\">\n\n      <h1 class=\"abs calibriBI 23-no\" style=\"left:925px;top:755px; font-size: 2.1em; font-weight:700; margin:0; color:#b4975a;\"  data-number='{\"to\": 32}' ></h1>\n      <h1 class=\"abs calibriBI 23-no\" style=\"left:1116px;top:755px; font-size: 2.1em; font-weight:700; margin:0; color:#00563f;\"  data-number='{\"to\": 32}' ></h1>\n\n\n      <img class=\"23-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"23-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg23Anim = new TimelineMax();\n        pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"23-img\")[0], 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n        .fromTo(cOf(\"23-img\")[1], 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n        .fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"23-no\")[0]);\n        }},1.5)\n        .fromTo(cOf(\"23-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){\n          animateNumber(cOf(\"23-no\")[1]);\n        }},1.7)\n        .fromTo(cOf(\"23-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"23-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg23Anim.stop();\n        removePulse(\"23-arrows\")\n      }\n      ",
    "searchText": "23  IGF Biennial Report 2019-20  YOG DAKAR 2022  Youth Olympic Games Dakar 2022 In July 2020, the IOC and the Senegal National Olympic Committee took the decision to postpone the 4th Summer Youth Olympic Games (YOG), scheduled to take place in Dakar, Senegal, in 2022, until 2026. This decision will allow the Olympic Movement to better manage the operational challenges resulting from the postponement of the Olympic Games Tokyo 2020. The 2026 Youth Olympic Games will remain in Senegal and will be the first Olympic event ever to be organised in Africa. We anticipate that the same event programme and athlete quota from Buenos Aires 2018 will be maintained  Events Individual stroke play female  and competitions will take place at the Golf de Sally golf course, 58km from the Youth Olympic Village. It is also expected that the Qualification System will be the same as that used for Nanjing 2014 and Buenos Aires 2018. However, the IOC will no longer permit combined National Olympic Committee (NOC) teams for the mixed team event. The IGF will continue with its planning and will provide further information on this to our membership as it becomes available.  Individual stroke play male Mixed (same NOC) team event (1 female and 1 male)  Athlete Quota 32  female  32  male"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      <img class=\"24-title halfScale\" src=\"/2019-20/static/_content/24-title-1.png\" style=\"top:237px; left: 55px;\">\n      <img class=\"24-title halfScale\" src=\"/2019-20/static/_content/24-sub-1.png\" style=\"top: 505px; left: 880px;\">\n      <img class=\"24-img halfScaleC\" src=\"/2019-20/static/_content/24-img-1.png\" style=\"top: 121px; left: -14px;\">\n      <img class=\"24-img halfScaleC\" src=\"/2019-20/static/_content/24-img-2.png\" style=\"top: 273px; left: 810px;\">\n\n      <img class=\"24-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"24-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg24Anim = new TimelineMax();\n        pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"24-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6)\n        .fromTo(cOf(\"24-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"24-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg24Anim.stop();\n        removePulse(\"24-arrows\")\n      }\n      ",
    "searchText": "24  IGF Biennial Report 2019-20  WATC FRANCE 2022  The IGF eagerly looks forward to successfully organising the 2022 WATC in France with our very experienced partners, the French Golf Federation (FFG). This will mark the third time the WATC has been played in France. The 1994 championships were previously played at Le Golf National (and La Boulie for the Eisenhower Trophy) and the inaugural Espirito Santo Trophy competition was played at St. Germain G.C. in 1964. Le Golf National – site of the 2018 Ryder Cup – and Golf de Saint-Nom-  Credit: WATC Paris 2022 Organising Committee  WATC France 2022  La-Bretèche near Paris will be the courses used for the championships. The 30th Women’s WATC for the Espirito Santo Trophy and the 33rd Men’s WATC for the Eisenhower Trophy will be played between 25-28 August and 1-4 September respectively.  Events  Women’s event 25-28 August  Men’s event 1-4 September  These championships will be a fantastic precursor to the Olympic Games Paris 2024 and will reinforce the strong link the WATC has with the Olympic Games, where at Rio 2016, 74 of the 120 athletes who competed had also represented their countries at the WATC."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n      <img class=\"25-title halfScale\" src=\"/2019-20/static/_content/25-title-1.png\" style=\"top:237px; left: 55px;\">\n\n      <img class=\"25-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"25-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg25Anim = new TimelineMax();\n        pg25Anim.staggerFromTo(cOf(\"25-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"25-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"25-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg25Anim.stop();\n        removePulse(\"25-arrows\")\n      }\n      ",
    "searchText": "25  WATC 2023  IGF Biennial Report 2019-20  WATC 2023 Following the cancellation of the 2020 WATC, the Administrative Committee opted to host the WATC following France 2022 in 2023 and not 2024, to establish, from then on, the WATC as a biennial competition held in odd years. This would end the conflict the WATC has with the Olympic Games and Youth Olympic Games, and would give rightful prominence of the WATC in those years, as well as priorities over resources to the WATC within the IGF. Following the vote of the 2018 Biennial Meeting, the 2023 WATC will become a one-course event per championship with a minimum number of 36 women’s teams and 36 men’s teams.  The membership will be asked to decide on the host of the 2023 WATC during the Biennial Meeting.  Beatrice Wallin of Sweden, WATC 2018"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"26-title halfScale\" src=\"/2019-20/static/_content/26-1-title-1.png\" style=\"top:265px; left: 55px;\">\n\n      <img class=\"26-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"26-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 26-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 26-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 26-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg26Anim = new TimelineMax();\n        pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"26-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"26-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg26Anim.stop();\n        removePulse(\"26-arrows\")\n      }\n      ",
    "searchText": "26  OLYMPIC GAMES PARIS 2024  IGF Biennial Report 2019-20  Olympic Games Paris 2024  The golf competitions at Paris 2024 will be held at the renowned Le Golf National, one of Europe’s top golf courses and a beautiful and innovative setting to welcome the highest levels  Credit: Steve Carr  Paris 2024 will host the Games of the XXXIII Olympiad from 26 July - 11 August 2024. The IOC Executive Board confirmed that all 28 sports from the Olympic Games Rio 2016 will return in 2024. The competition format for all sports is due to be confirmed by the IOC Executive Board by the end of 2020. of international competition. Le Golf National is located in Saint-Quentinen-Yvelines, 41 km from the Olympic Village. Owned and managed by the French Golf Federation, the venue was conceived as a permanent home for READ MORE  the annual French Open tournament and as a national training facility. Le Golf National opened in 1991 and was fully renovated in 2016. In 2018, Le Golf National hosted the Ryder Cup."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"26-img halfScaleC\" src=\"/2019-20/static/_content/26-2-img-1.png\" style=\"top: 272px; left: 996px;\">\n      <img class=\"26-title halfScale\" src=\"/2019-20/static/_content/26-2-sub-1.png\" style=\"top:408px; left: 970px;\">\n\n      <img class=\"26-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"26-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg26Anim = new TimelineMax();\n        pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, \"-=0.2\")\n        .fromTo(cOf(\"26-img\"), 0.8, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n        .fromTo(cOf(\"26-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"26-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg26Anim.stop();\n        removePulse(\"26-arrows\")\n      }\n      ",
    "searchText": "26  Post-Games Legacy Following the Olympic Games Paris 2024, Le Golf National will resume its role as the national high-performance training centre of the French Golf Federation and the host of the annual French Open, as well as a sports complex open to the community.  New Games Delivery Model In line with the objectives set by the IOC’s Olympic Agenda 2020 and “The New Norm”, a new approach is being taken for the Olympic Games in 2024 whereby the Games Delivery model is evolving to support the overarching objectives to reduce the  OLYMPIC GAMES PARIS 2024  cost and complexity of the Olympic Games. Within this new approach, the concept is to maximise the use of existing expertise in each sport while ensuring efficient planning and delivery of the events. The IGF and its Delivery partners, together with the IOC and the Paris 2024 Organising Committee, is working on the development of this new framework and ultimately a more hands-on approach to the delivery of the Olympic events by the IF beyond the traditional field-ofplay boundary seen at past Games. The IGF looks forward to harnessing golf’s immense wealth of expertise and knowledge in delivering world  IGF Biennial Report 2019-20  Venue: Le Golf National Opened: 1991 Hosted: 2018 Ryder Cup  class events to produce a spectacular, sustainable and memorable Olympic golf competition for our athletes in 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <img class=\"27-title halfScale\" src=\"/2019-20/static/_content/27-title-1.png\" style=\"top:265px; left: 55px;\">\n\n      <img class=\"27-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"27-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg27Anim = new TimelineMax();\n        pg27Anim.staggerFromTo(cOf(\"27-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"27-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"27-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg27Anim.stop();\n        removePulse(\"27-arrows\")\n      }\n      ",
    "searchText": "27  OTHER MULTI-SPORT EVENTS AND ORGANISATIONS  IGF Biennial Report 2019-20  Ayean Cho of Republic of Korea (bronze medallist), WATC 2018  Other multi-sport events and organisations As the recognised International Federation for golf within the Olympic Movement, the IGF has undertaken roles within the organisation of IOCrecognised multi-sport events such as the World Masters Games, Pan American Games, Asian Games, International University Sports Federation (FISU) Universiade and FISU World University Golf Championships.   Appointment of Technical Delegate  Development and Oversight of Qualification System  Development of Event Regulations  Control over the Competition  The IGF’s role within these events consists of:   Appointment of Rules Officials  Following the repeated success of more than 500 competitors at the golf competitions at the 2013 Torino and 2017 Auckland World Masters Games, the IGF in 2019 was granted full membership of the International World Masters Games Association (IWMGA) at its General Assembly held at the Gold Coast. The next World Masters Games will be held in Kansai, Japan in 2021."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"28-title halfScale\" src=\"/2019-20/static/_content/28-1-title-1.png\" style=\"top:205px; left: 55px;\">\n      <img class=\"28-title halfScale\" src=\"/2019-20/static/_content/28-1-sub-1.png\" style=\"top: 337px; left: 55px;\">\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 28-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 28-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 28-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2018  Report of the independent auditors to the Board of Directors on the financial statements 2018 Report of the independent auditors on the limited statutor y examination to the Board of Directors of International Golf Federation Lausanne  As independent auditors, we have examined the financial statements of International Golf Federation, which comprise the balance sheet, income statement and notes, for the year ended 31 December 2018. The  financial statements for the year ended 31 December 2018 were subject to a limited statutory examination and the prior year’s financial statements to an ordinary audit. These financial statements are the responsibility of the Management. Our responsibility is to perform a limited statutory examination on these financial statements. We confirm that we meet the licensing and independence requirements as stipulated by Swiss law. We conducted our examination in accordance with the Swiss Standard READ MORE  on Limited Statutory Examination. This standard requires that we plan and perform a limited statutory examination to identify material misstatements in the financial statements. A limited statutory examination consists primarily of inquiries of association personnel and analytical procedures as well as detailed tests of association documents as considered appropriate in the circumstances. However, the testing of the operational processes and the internal control system, as well as inquiries and further testing procedures to detect fraud or other legal violations, are not within the scope of this examination."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  IGF FINANCIAL REPORT 2018  IGF Biennial Report 2019-20  Sophie Hausmann of Germany, WATC 2018  Based on our limited statutory examination, nothing has come to our attention that causes us to believe that the financial statements do not comply with Swiss law and the association’s articles of incorporation. We draw your attention to the fact that the financial statements of International Golf Federation disclose negative equity amounting to CHF 13’433. PricewaterhouseCoopers SA Philippe Tzaud Audit expert Auditor in charge Nicolas Daehler Audit expert  Lausanne, 21 March 2019 Enclosure: Financial statements (balance sheet, income statement and notes)"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2018  NOTES  2018 CHF  2017 CHF  2018 USD  2017 USD  340’552  2'174'032  345’871  2’121’964  0  9'230  0  9'009  29'481  80'769  29'942  78'835  370'033  2'264'031  375'813  2'209'807  ASSETS CURRENT ASSETS Cash at bank and in hand Accounts receivable  Balance sheet at December 31 In Swiss Francs with convenience translation into US dollar  Prepaid expenses & other assets  3  FIXED ASSETS Tangible fixed assets  4  1’040  2’360  1’056  2’303  Intangible fixed assets  5  17'979  29'033  18'260  28'338  19'019  31'393  19'316  30'641  389'052  2'295'424  395'129  2'240'449  284’627  521’651  289’073  509’157  117'858  110’251  119’699  107’610  402'485  631'902  408’772  616’768  Accumulated income/(losses)  - 13’433  1'663'523  - 13’643  1’623’681  TOTAL LIABILITIES AND FUNDS  389’052  2‘295’424  395’129  2’240’449  TOTAL ASSETS  LIABILITIES AND FUNDS CURRENT LIABILITIES Accounts payable Accrued and other payables  6  FUNDS"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-4.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2018  2018 CHF  2017 CHF  2018 USD  2017 USD  IOC contribution  68'456  71'107  70'000  70'000  Youth Olympic Games contribution  137'038  0  140'130  0  Subscription for championship  98'977  0  101’210  0  Other income  249'510  12'406  255'139  12'213  553'981  83'514  566'479  82'213  1'100'726  1'034'089  1'125'559  1'017'989  Travel and representation  222'193  209'279  227'206  206'020  Olympic Games related expenditures  45'109  48'834  46'127  48'073  YOG relative expenses  145'520  0  148'803  0  Marketing and communication  167'681  23'032  171'463  22'673  Office costs  88'203  99'673  90'193  98'122  Fees  262'059  198'624  267'971  195'532  0  1'362  0  1'340  Exchange loss/(gain)  32'240  37'581  32'967  36'996  Translation adjustment  75'755  -2'778  0  0  Other expenditure  80'206  257'238  82'016  253'233  Amortisation  11'245  3'734  11'498  3'676  2'230'937  1'910'669  2'203'803  1'883'655  EXCESS OF INCOME OVER EXPENDITURE (EXPENDITURE OVER INCOME) FOR THE YEAR  -1'676'956  -1'827'155  -1'637'324  -1'801'442  Accumulated income/(loss) at beginning  1'663'523  3'490'678  1'623'680  3'425'122  - 13’433  1’663’523  - 13’645  1’623’680  NOTES INCOME  Statement of income and expenditure for the years 2018 and 2017 In Swiss Francs with convenience translation into US dollar  EXPENDITURE Staff costs  Interest expenses  ACCUMULATED INCOME/(LOSS) AT END OF THE PERIOD  7"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-5.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  Notes to the financial statements 2018 and 2017 In Swiss Francs with convenience translation into US dollar 1. Activity The International Golf Federation (IGF) is the world-wide Golf sports organisation, the headquarters of which are located in Lausanne, Switzerland. The objectives of International Golf Federation are: a. to encourage the international development of the sport of golf;  IGF FINANCIAL REPORT 2018  b. to foster friendship and sportmanship among the peoples of the world by organising biennially amateur team championships for the Eisenhower Trophy (for men) and the Espirito Santo trophy (for women); c. to promote golf as an Olympic sport; and d. to act as the International Federation for golf in the Olympic Games and thereby to establish and enforce, in accordance with the Olympic spirit, the rules concerning the playing of golf in the Olympic Games and to fulfil in respect of the sport of golf the mission and role of an International Federation within the Olympic movement.  IGF Biennial Report 2019-20  2. Summary of significant accounting policies 2.1 Basis of accounting IGF uses the accruals basis of accounting in preparing the financial statements. 2.2 Fixed assets Fixed assets are stated at acquisition cost. When assets are retired or otherwise disposed of, the cost of the asset and the related accumulated depreciation are removed from the accounts. Any profit or loss on retirement is reflected in the earnings for the period."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-6.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  2.3 Depreciation Depreciation is calculated on the basis of the cost of the assets and on their estimated useful lives using the reducing balance method. 2.4 Deferred income Any funds received for events to be held in the future, where reimbursement of these funds would be necessary in the case of event cancellation, are deferred in the balance sheet and not recognised as income until the event for which the funds were received has taken place.  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2018  2.5 Accounting for foreign currencies The functional currency of IGF is the US dollar. Assets and liabilities denominated in currencies other  than US dollar are recorded based on exchange rates ruling at the yearend. Transactions denominated in currencies other than US dollar  2018 CHF  2017 CHF  2018 USD  2017 USD  Taxes  5'074  44'968  5'153  43'891  Other prepaid expenditures  24'407  35'801  24'789  34'944  29'481  80'769  29'942  78'835  0  241  0  236  1'040  2'119  1'056  2'068  1'040  2'360  1'056  2'303  17'979  29'033  18'260  28'338  17'979  29'033  18'260  28'338  3. PREPAID EXPENSES AND OTHER CURRENT ASSETS  4. TANGIBLE FIXED ASSETS, NET OF DEPRECIATION IT equipment Furnitures and office equipment 5. INTANGIBLE FIXED ASSETS, NET OF DEPRECIATION Software"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28-7.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"28-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"28-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"28-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removePulse(\"28-arrows\")\n      }\n      ",
    "searchText": "28  are recorded at average rates for the year. All exchange losses and realised exchange gains are recognised in the statement of income and expenditure. Financial statements are converted for presentation purpose into Swiss Francs as of the year end. Assets and liabilities are converted using the exchange rate at the year end whereas elements of the statement of income and expenditure are converted using the average exchange rate over the period. The difference arising from the conversion is recognised as translation gain or loss of the period in the statement of income and expenditure.  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2018  2018 CHF  2017 CHF  2018 USD  2017 USD  Social charges  50'160  36'488  50'944  35'614  Other accruals  5'500  0  5'586  0  Other payables  62'198  73'763  63'169  71'997  117'858  110'251  119'699  107'610  Gross salary  884'013  792'685  903'956  780'343  Social charges  142'720  139'511  145'939  137'339  Other staff costs  73'994  101'893  75'663  100'307  1'100'726  1'034'089  1'125'559  1'017'989  6. ACCRUED AND OTHER PAYABLES  7. STAFF COSTS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"29-title halfScale\" src=\"/2019-20/static/_content/29-1-title-1.png\" style=\"top:235px; left: 55px;\">\n      <img class=\"29-title halfScale\" src=\"/2019-20/static/_content/29-1-sub-1.png\" style=\"top: 367px; left: 55px;\">\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 29-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 29-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 29-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  Report of the statutory auditors to the Board of Directors on the financial statements 2019 Report of the statutory auditors on the limited statutor y examination to the Board of Directors of International Golf Federation Lausanne  As statutory auditors, we have examined the financial statements of International Golf Federation, which comprise the balance sheet, statement of income and expenditures and notes, for the year ended 31 December 2019.  These financial statements are the responsibility of the Management. Our responsibility is to perform a limited statutory examination on these financial statements. We confirm that we meet the licensing and independence requirements as stipulated by Swiss law. We conducted our examination in accordance with the Swiss Standard on Limited Statutory Examination. This standard requires that we plan and perform a limited statutory examination to identify material misstatements in the financial statements. A limited READ MORE  statutory examination consists primarily of inquiries of foundation personnel and analytical procedures as well as detailed tests of foundation documents as considered appropriate in the circumstances. However, the testing of the operational processes and the internal control system, as well as inquiries and further testing procedures to detect fraud or other legal violations, are not within the scope of this examination. Based on our limited statutory examination, nothing has come to our attention that causes us to"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  IGF FINANCIAL REPORT 2019  IGF Biennial Report 2019-20  Vaclav Tichy of Czech Republic, YOG 2018  believe that the financial statements do not comply with Swiss law and the association’s articles of incorporation. We draw your attention to the fact that the financial statements of International Golf Federation disclose an excess of liabilities over assets. PricewaterhouseCoopers SA Philippe Tzaud Audit expert Auditor in charge Nicolas Daehler Audit expert  Lausanne, 17 April 2020 Enclosure: Financial statements (balance sheet, income statement and notes)"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  NOTES  2019 CHF  2018 CHF  2019 USD  2018 USD  598’970  340’552  616’796  345’871  0  0  0  0  474'305  29'481  488'420  29'942  1'073'275  370'033  1'105'216  375'813  ASSETS CURRENT ASSETS Cash at bank and in hand Accounts receivable Prepaid expenses & other assets  Balance sheet at December 31 In Swiss Francs with convenience translation into US dollar  3  FIXED ASSETS Tangible fixed assets  4  1’313  1’040  1’352  1’056  Intangible fixed assets  5  7'609  17'979  7'836  18'260  8'922  19'019  9'188  19'316  1'082'197  389'052  1'114'403  395'129  215’855  294’627  222’279  299’073  448'554  117'858  461'900  119'699  664'408  402'485  684'179  408'772  2'209'253  0  2'275'000  0  2'209'253  0  2'275'000  0  - 1’791’464  - 13’433  - 1’844’778  - 13’643  1’082’197  389’052  1’114’401  395’129  TOTAL ASSETS  LIABILITIES AND FUNDS CURRENT LIABILITIES Accounts payable Accrued and other payables  6  ΝΟΝ-CURRENT LIABILITIES Subordinated long term loans  7  FUNDS Accumulated income/(losses) TOTAL LIABILITIES AND FUNDS"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-4.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  2019 CHF  2018 CHF  2019 USD  2018 USD  74'901  68'456  76'600  70'000  Youth Olympic Games contribution  0  137'038  0  140'130  Subscription for championship  0  98'977  0  101'210  Other income  0  249'510  0  255'139  74'901  553'981  76'600  566'479  1'037'331  1'100'726  1'060'868  1'125'559  Travel and representation  197'665  222'193  202'150  227'206  Olympic Games related expenditures  43'786  45'109  44'779  46'127  0  145'520  0  148'803  Marketing and communication  26'952  167'681  27'564  171'463  Office costs  96'406  88'203  98'593  90'193  Fees  198'266  262'059  202'765  267'971  Interest expenses  43'354  0  44'337  0  Exchange loss/(gain)  43'402  32'240  44'385  32'967  Translation adjustment  -12’478  75’755  0  0  Other expenditure  166'701  80'206  170'484  82'016  11'546  11'245  11'807  11'498  1'852'931  2'230'937  1'907'733  2'203'803  -1’778’030  -1’676’956  -1’831’133  -1’637’324  - 13’433  1’663’523  - 13’645  1’623’680  - 1’791’464  - 13'433  - 1’844’777  - 13’645  NOTES INCOME IOC contribution  Statement of income and expenditure for the years 2019 and 2018 In Swiss Francs with convenience translation into US dollar  EXPENDITURE Staff costs  YOG relative expenses  Amortisation EXCESS OF INCOME OVER EXPENDITURE (EXPENDITURE OVER INCOME) FOR THE YEAR Accumulated income/(loss) at beginning ACCUMULATED INCOME/(LOSS) AT END OF THE PERIOD  8"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-5.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  Notes to the financial statements 2019 and 2018 In Swiss Francs with convenience translation into US dollar 1. Activity The International Golf Federation (IGF) is the world-wide Golf sports organisation, the headquarters of which are located in Lausanne, Switzerland. The objectives of International Golf Federation are: a. to encourage the international development of the sport of golf;  IGF FINANCIAL REPORT 2019  b. to foster friendship and sportmanship among the peoples of the world by organising biennially amateur team championships for the Eisenhower Trophy (for men) and the Espirito Santo trophy (for women); c. to promote golf as an Olympic sport; and d. to act as the International Federation for golf in the Olympic Games and thereby to establish and enforce, in accordance with the Olympic spirit, the rules concerning the playing of golf in the Olympic Games and to fulfil in respect of the sport of golf the mission and role of an International Federation within the Olympic movement.  IGF Biennial Report 2019-20  2. Summary of significant accounting policies 2.1 Basis of accounting IGF uses the accruals basis of accounting in preparing the financial statements. 2.2 Fixed assets Fixed assets are stated at acquisition cost. When assets are retired or otherwise disposed of, the cost of the asset and the related accumulated depreciation are removed from the accounts. Any profit or loss on retirement is reflected in the earnings for the period."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-6.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  2.3 Depreciation Depreciation is calculated on the basis of the cost of the assets and on their estimated useful lives using the reducing balance method. 2.4 Deferred income Any funds received for events to be held in the future, where reimbursement of these funds would be necessary in the case of event cancellation, are deferred in the balance sheet and not recognised as income until the event for which the funds were received has taken place.  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  2.5 Accounting for foreign currencies The functional currency of IGF is the US dollar. Assets and liabilities denominated in currencies other  than US dollar are recorded based on exchange rates ruling at the year-end. Transactions denominated in currencies other than US dollar  2019 CHF  2018 CHF  2019 USD  2018 USD  45'011  5'074  46'351  5'153  Tokyo prepaid expenditures  422'144  0  434'707  0  Other prepaid expenditures  7'149  24'407  7'362  24'789  474'305  29'481  488'420  29'942  1'270  0  1'307  0  43  1'040  44  1'056  1'313  1'040  1'352  1'056  7'609  17'979  7'836  18'260  7'609  17'979  7'836  18'260  3. PREPAID EXPENSES AND OTHER CURRENT ASSETS Taxes  4. TANGIBLE FIXED ASSETS, NET OF DEPRECIATION IT equipment Furnitures and office equipment 5. INTANGIBLE FIXED ASSETS, NET OF DEPRECIATION Software"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-7.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  are recorded at average rates for the year. All exchange losses and realised exchange gains are recognised in the statement of income and expenditure. Financial statements are converted for presentation purpose into Swiss Francs as of the year end. Assets and liabilities are converted using the exchange rate at the year end whereas elements of the statement of income and expenditure are converted using the average exchange rate over the period. The difference arising from the conversion is recognised as conversion gain or loss of the period in the statement of income and expenditure.  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  2019 CHF  2018 CHF  2019 USD  2018 USD  Social charges  33'543  50'160  34'542  50'944  Interest accrual  43'056  0  44'337  0  Tokyo deferred income  336'368  0  346'379  0  Other accruals  5'500  5'500  5'664  5'586  Other payables  30'086  62'198  30'979  63'169  448'554  117'858  461'900  119'699  Europa Tour  339'885  0  350'000  0  LPGA  169'943  0  175'000  0  PGA of America  339'885  0  350'000  0  PGA Tour  339'885  0  350'000  0  R&A  339'885  0  350'000  0  USGA  339'885  0  350'000  0  Master Tournament Foundation Inc.  339'885  0  350'000  0  2'209'253  0  2'275'000  0  6. ACCRUED AND OTHER PAYABLES  7. SUBORDINATED LONG-TERM LOANS  Accumulated losses are fully covered by the subordinated loans."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29-8.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"29-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"29-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"29-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg29Anim.stop();\n        removePulse(\"29-arrows\")\n      }\n      ",
    "searchText": "29  9. Significant event occuring after the balance sheet date In January 2020, coronavirus outbreak occurred in China and has now been spread to Europe and other regions. This is impacting the federation’s business operation to a certain extent. The actual financial impact, in particular linked to the postponement of the Olympic Games in Japan, will depend on the situation and duration of coronavirus outbreak, which is hard to estimate now. Nevertheless, the Board of Directors believe that there is no material uncertainty that may cast significant doubt upon the federation’s ability to continue as a going concern.  IGF Biennial Report 2019-20  IGF FINANCIAL REPORT 2019  2019 CHF  2018 CHF  2019 USD  2018 USD  Gross salary  879'623  884'013  899'581  903'956  Social charges  157'708  142'720  161'287  145'939  0  73’994  0  75'663  1'037'331  1'100'726  1'060'868  1'125'559  8. STAFF COSTS  Other staff costs"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30-1.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      <img class=\"pointer 30-arrows\" src=\"/2019-20/static/_content/read-more.png\" style=\"bottom: 15px; left: 594px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 30-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 567px;\" onclick=\"Publish.goToNextSection()\">\n      <img class=\"pointer 30-arrows\" src=\"/2019-20/static/_content/down-arrow-gold.png\" style=\"bottom: 15px; left: 691px;\" onclick=\"Publish.goToNextSection()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg30Anim = new TimelineMax();\n        pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"30-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"30-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop();\n        removePulse(\"30-arrows\")\n      }\n      ",
    "searchText": "30  IGF Biennial Report 2019-20  APPENDICES  National Federation Members Afghanistan Golf Federation  Colombian Golf Federation  Golf Association in Bosnia and Herzegovina  Algeria Golf Federation  Cook Islands Golf Association  Golf Association of Moldova  Andorra Golf Federation  Costa Rican Golf Federation  Golf Association of Serbia  Argentina Golf Association  Côte d'Ivoire Golf Federation  Golf Association of Slovenia  Austrian Golf Association  Croatian Golf Association  Golf Australia  Azerbaijan Golf Federation  Cyprus Golf Federation  Golf Canada  Bahamas Golf Federation  Czech Golf Federation  Golf Federation in Kyrgyzstan  Bahrain Golf Association  Danish Golf Union  Golf Federation of Haiti  Bangladesh Golf Federation  Democratic Republic of Congo Golf Federation  Golf Fiji  Barbados Golf Association  Dominican Golf Federation  Golf Union of Iceland  Belarusian Golf Association  Ecuador Golf Federation  Golf Union of Malawi  Benin Golf Federation  Egyptian Golf Federation  Golf Union of Wales  Bermuda Golf Association  El Salvador Golf Federation  Golfing Union of Ireland  Bolivian Golf Federation  Emirates Golf Federation  GolfRSA t/a South African Golf Association  Botswana Golf Union  England Golf  Guam National Golf Federation  Brazilian Golf Confederation  Estonian Golf Association  Guatemala National Golf Association  Bulgarian Golf Association  Finnish Golf Union  Hellenic Golf Federation  Cambodian Golf Federation  French Golf Federation  Honduras Golf Association  Cayman Islands Golf Association  Gabon Golf Union  Hong Kong Golf Association, Ltd.  Chilean Golf Federation  Gambia Golf Association  Hungarian Golf Federation  China Golf Association  German Golf Association  Indian Golf Union  Chinese Taipei Golf Association  Ghana Golf Association  Indonesia Golf Association  READ MORE"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30-2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg30Anim = new TimelineMax();\n        pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"30-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"30-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop();\n        removePulse(\"30-arrows\")\n      }\n      ",
    "searchText": "30  IGF Biennial Report 2019-20  APPENDICES  Iraqi Golf Federation  New Zealand Golf  St Lucia Golf Association  Irish Ladies Golf Union  Nicaraguan Golf Association  Swaziland Golf Union  Islamic Republic of Iran Golf Federation  Nigeria Golf Federation  Swedish Golf Federation  Israel Golf Federation  Norwegian Golf Federation  Swiss Golf Association  Italian Golf Federation  Oman Golf Committee  Tanzania Golf Union  Jamaica Golf Association  Pakistan Golf Federation  Thailand Golf Association  Japan Golf Association  Panama Golf Association  Trinidad and Tobago Golf Association  Jordan Golf Federation  Papua New Guinea Golf Association  Tunisia Golf Federation  Kazakhstan Golf Federation  Paraguay Golf Association  Turkish Golf Federation  Kenya Golf Union  Peruvian Golf Federation  Turks and Caicos Islands Golf Association  Korea Golf Association  Polish Golf Union  Uganda Golf Union  Kuwait Golf Association  Portuguese Golf Federation  Ukrainian Golf Federation  Latvian Golf Federation  Principality of Monaco Golf Federation  Uruguay Golf Association  Lebanese Golf Federation  Puerto Rico Golf Association  USA Golf Federation, Inc  Libyan Golf Federation  Qatar Golf Association  Uzbekistan Golf Federation  Liechtenstein Golf Association  Romanian Golf Federation  Vanuatu Golf Association  Lithuanian Golf Federation  Royal Belgian Golf Federation  Venezuelan Golf Federation  Luxembourg Golf Federation  Royal Moroccan Golf Federation  Vietnam Golf Association  Macedonian Golf Federation  Royal Spanish Golf Federation  Virgin Islands Golf Federation  Madagascar Golf Federation  Russian Golf Association  Women's Golf South Africa  Malaysian Golf Association  Samoa Golf Incorporated  Zambia Golf Union  Malta Golf Association  San Marino Golf Federation  Zimbabwe Golf Association  Mauritius Golf Federation  Saudi Arabian Golf Federation  Mexican Golf Federation  Scottish Golf Limited  Mongolian Golf Association  Senegal Golf Federation  Myanmar Golf Federation  Seychelles Golf Federation  Namibia Golf Federation  Singapore Golf Association  National Golf Association of Armenia  Slovak Golf Association  National Golf Association of the Philippines  Solomon Islands Golf Federation  Netherlands Golf Federation  Sri Lanka Golf Union"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30-3.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/left-arrow.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n      <img class=\"30-arrows pointer\" src=\"/2019-20/static/_content/right-arrow.png\" style=\"top: 427px; right: 10px;\" onclick=\"Publish.goToNextPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg30Anim = new TimelineMax();\n        pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.6, {opacity:0, y:-50}, {opacity:1, y:0}, 0.3, 1)\n        .fromTo(cOf(\"30-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: addPulse(\"30-arrows\")}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop();\n        removePulse(\"30-arrows\")\n      }\n      ",
    "searchText": "30  APPENDICES  IGF Biennial Report 2019-20  Professional Members Asian Tour Augusta National Australian Ladies Professional Golf Tour Confederation of Professional Golf International Federation of PGA Tours International Golf Association Japan Golf Tour Organization Korea Ladies Professional Golf Association Korea Professional Golfers’ Association Ladies Asian Golf Tour Ltd. Ladies European Tour Ladies Professional Golf Association PGA European Tour PGA of America PGA of Australia / PGA Tour of Australasia PGA TOUR Professional Golf Tour of India Sunshine Tour The Ladies Professional Golfers’ Association of Japan The Professional Golfers’ Association The R&A United States Golf Association  Cole Stevens of South Africa, YOG 2018"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <a href=\"http://www.igfgolf.org\" target=\"_blank\">\n      <div class=\"contentLink\" style=\"bottom: 22px;right: 80px;width: 115px;height: 23px;\"></div>\n    </a>\n    <img class=\"31-arrows pointer\" src=\"/2019-20/static/_content/left-arrow-white.png\" style=\"top: 427px; left: 10px;\" onclick=\"Publish.goToPreviousPage()\">\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg31Anim = new TimelineMax();\n        pg31Anim.staggerFromTo(cOf(\"31-title\"), 0.6, {opacity:0, y:-30}, {opacity:1, y:0}, 0.2, 1)        \n        .fromTo(cOf(\"31-arrows\"), 0.6, {opacity:0}, {opacity:1, onComplete: function() {\n          addPulse(\"31-arrows\")\n          addContentLinks()\n        }}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg31Anim.stop();\n      }\n      ",
    "searchText": "IGF Biennial Report 2019-20  INTERNATIONAL GOLF FEDERATION Avenue de Rhodanie 54 1007 Lausanne, Switzerland  Tel +41 21 623 12 12 Fax +41 21 601 64 77 www.igfgolf.org"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function addPulse(ele) {\n        var elements = cOf(ele)\n        for(var i=0; i<elements.length; i++) {\n          elements[i].className += \" pulse animatedpulse\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {

    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-21',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "QRRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UR7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WI9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zhdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "be29":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "clAw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f34v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gUQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1X4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mp9z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7029e4fb7cac97c352ed.js